var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentsAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-38",
    d: "M77.66,245.8c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,190.84,77.66,245.8Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-38",
    points: "14.4 343.14 46.1 361.44 204.61 269.93 172.92 251.63 14.4 343.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-38",
    points: "485.6 343.14 453.9 361.44 295.39 269.93 327.08 251.63 485.6 343.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-38",
    cx: 182.55,
    cy: 344.51,
    rx: 47.07,
    ry: 27.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-38",
    cx: 315.42,
    cy: 344.51,
    rx: 47.07,
    ry: 27.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-38",
    cx: 95.59,
    cy: 397.28,
    rx: 48.7,
    ry: 28.12,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-38",
    cx: 408.06,
    cy: 394.99,
    rx: 46.49,
    ry: 26.84,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.42,47.28h0l-5-2.89h0l0,0h0c-3.14-1.59-7.33-1.13-11.85,1.78C69.44,52,62.51,65.46,63,76.24c.26,5.37,2.33,9.06,5.45,10.68h0l0,0h0l5,2.89h0l0,0h0c3.14,1.59,7.33,1.13,11.85-1.78,9.08-5.85,16-19.32,15.48-30.1C100.61,52.6,98.55,48.91,95.42,47.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,89.71l-4.75-2.77h0l0,0C65.35,85.29,63.29,81.6,63,76.24a33.6,33.6,0,0,1,3.28-15.11l5,2.89A33.45,33.45,0,0,0,68,79.13C68.27,84.38,70.25,88,73.27,89.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.39,88.07c9.08-5.85,16-19.32,15.48-30.1S92.57,43.19,83.5,49,67.5,68.35,68,79.13,76.32,93.91,85.39,88.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,87.31c-5.35.26-6.22-5.75-6.34-8.35-.47-9.51,5.9-21.89,13.91-27a12.19,12.19,0,0,1,5.74-2.14c5.35-.26,6.22,5.76,6.35,8.36.46,9.5-5.91,21.89-13.91,27a12.13,12.13,0,0,1-5.75,2.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,70.33a.59.59,0,0,1-.59-.58V56a.59.59,0,0,1,1.17,0V68.05l6.41-8.24a.58.58,0,0,1,.92.72L86,70.11A.61.61,0,0,1,85.5,70.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.21,80.49h-.08a.26.26,0,0,1-.17-.31L85.19,69.3a.25.25,0,0,1,.31-.17.25.25,0,0,1,.16.31L82.43,80.31A.24.24,0,0,1,82.21,80.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.31,67c1.07-.69,2-.22,2,1a4.41,4.41,0,0,1-1.83,3.54c-1.06.69-2,.22-2-1A4.4,4.4,0,0,1,85.31,67Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lockers--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lockers--inject-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.35 298.66 119.4 282.52 119.4 80.8 147.35 96.94 147.35 298.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.35 96.94 196.26 68.7 196.27 270.42 147.35 298.66 147.35 96.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,290.58a.92.92,0,0,1-.43-.11.89.89,0,0,1-.43-.75V99.92a.89.89,0,0,1,.43-.75l38.59-22.28a.88.88,0,0,1,.86,0,.86.86,0,0,1,.43.75v189.8a.84.84,0,0,1-.43.74l-38.59,22.29A.92.92,0,0,1,152.51,290.58Zm.86-190.16V288.23l36.87-21.29V79.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.26 68.7 168.31 52.56 119.4 80.8 147.35 96.94 196.26 68.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31,102.13l11-6.35c.82-.47,1.49-.09,1.49.86v4.63a3.29,3.29,0,0,1-1.49,2.58l-11,6.35c-.82.48-1.49.09-1.49-.86v-4.63A3.31,3.31,0,0,1,166.31,102.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64,110.74a1.08,1.08,0,0,1-.55-.15,1.35,1.35,0,0,1-.6-1.25v-4.63a3.59,3.59,0,0,1,1.66-2.86l11-6.35a1.23,1.23,0,0,1,2,1.15v4.62a3.62,3.62,0,0,1-1.66,2.87l-11,6.35A1.76,1.76,0,0,1,165.64,110.74Zm.84-8.32h0a3,3,0,0,0-1.33,2.29v4.63a.76.76,0,0,0,.27.68.78.78,0,0,0,.73-.1l11-6.35a3,3,0,0,0,1.33-2.3V96.65a.73.73,0,0,0-.28-.68.76.76,0,0,0-.72.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 121.33 161 124.67 181.97 112.57 181.97 109.23 161 121.33",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 121.33 181.97 109.23 182.62 111.31 161.65 123.41 161 121.33",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 125.72 161 129.05 181.97 116.95 181.97 113.61 161 125.72",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 125.72 181.97 113.61 182.62 115.69 161.65 127.79 161 125.72",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 130.1 161 133.44 181.97 121.33 181.97 118 161 130.1",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 130.1 181.97 118 182.62 120.07 161.65 132.18 161 130.1",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 134.49 161 137.82 181.97 125.72 181.97 122.38 161 134.49",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 134.49 181.97 122.38 182.62 124.46 161.65 136.56 161 134.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 258.51 161 261.85 181.97 249.74 181.97 246.41 161 258.51",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 258.51 181.97 246.41 182.62 248.48 161.65 260.58 161 258.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 262.89 161 266.23 181.97 254.13 181.97 250.79 161 262.89",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 262.89 181.97 250.79 182.62 252.87 161.65 264.97 161 262.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 267.28 161 270.61 181.97 258.51 181.97 255.17 161 267.28",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 267.28 181.97 255.17 182.62 257.25 161.65 269.35 161 267.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 271.66 161 275 181.97 262.89 181.97 259.56 161 271.66",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161 271.66 181.97 259.56 182.62 261.63 161.65 273.74 161 271.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.3,162.52a1,1,0,0,0-1,.1l-4,2.32a3.29,3.29,0,0,0-1.49,2.58v20.76a1,1,0,0,0,.43.94l1.07.61a1,1,0,0,0,1-.1l4-2.31a3.31,3.31,0,0,0,1.49-2.58V164.07a1,1,0,0,0-.42-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.3,163.21l-4,2.31a3.33,3.33,0,0,0-1.49,2.59v20.76c0,.95.67,1.34,1.49.86l4-2.31a3.31,3.31,0,0,0,1.49-2.58V164.07C187.79,163.12,187.12,162.74,186.3,163.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.67,165l-2.75,1.59a2.25,2.25,0,0,0-1,1.77v14.22c0,.65.46.92,1,.59l2.75-1.58a2.28,2.28,0,0,0,1-1.77V165.55C186.69,164.9,186.23,164.64,185.67,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.94,165.12a.93.93,0,0,0-.05-.24c-.07,0-.14,0-.22.08l-2.75,1.59a2.25,2.25,0,0,0-1,1.77v14.22a.78.78,0,0,0,0,.23,1.11,1.11,0,0,0,.22-.07l2.75-1.59a2.25,2.25,0,0,0,1-1.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.44 326.9 70.49 310.76 70.48 109.04 98.44 125.18 98.44 326.9",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.44 125.18 147.35 96.94 147.35 298.66 98.44 326.9 98.44 125.18",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,318.82a.92.92,0,0,1-.43-.11.86.86,0,0,1-.43-.75V128.16a.84.84,0,0,1,.43-.74l38.59-22.29a.88.88,0,0,1,.86,0,.86.86,0,0,1,.43.75v189.8a.84.84,0,0,1-.43.74L104,318.71A1,1,0,0,1,103.6,318.82Zm.86-190.16V316.47l36.87-21.29V107.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.35 96.94 119.4 80.8 70.48 109.04 98.44 125.18 147.35 96.94",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,130.37l11-6.34c.82-.48,1.49-.09,1.49.86v4.62a3.29,3.29,0,0,1-1.49,2.58l-11,6.35c-.83.48-1.49.09-1.49-.86V133A3.28,3.28,0,0,1,117.4,130.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,139a1,1,0,0,1-.55-.15,1.34,1.34,0,0,1-.6-1.25V133a3.58,3.58,0,0,1,1.65-2.86l11-6.35a1.23,1.23,0,0,1,2,1.15v4.62a3.6,3.6,0,0,1-1.65,2.87l-11,6.35A1.65,1.65,0,0,1,116.73,139Zm.83-8.32a3,3,0,0,0-1.32,2.29v4.63a.59.59,0,0,0,1,.58l11-6.35a3,3,0,0,0,1.32-2.3v-4.62a.59.59,0,0,0-1-.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 149.57 112.09 152.91 133.05 140.81 133.05 137.47 112.09 149.57",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 149.57 133.05 137.47 133.7 139.55 112.74 151.65 112.09 149.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 153.96 112.09 157.29 133.05 145.19 133.05 141.85 112.09 153.96",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 153.96 133.05 141.85 133.7 143.93 112.74 156.03 112.09 153.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 158.34 112.09 161.68 133.05 149.57 133.05 146.24 112.09 158.34",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 158.34 133.05 146.24 133.7 148.31 112.74 160.42 112.09 158.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 162.73 112.09 166.06 133.05 153.96 133.05 150.62 112.09 162.73",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 162.73 133.05 150.62 133.7 152.7 112.74 164.8 112.09 162.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 286.75 112.09 290.09 133.05 277.98 133.05 274.65 112.09 286.75",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 286.75 133.05 274.65 133.7 276.72 112.74 288.83 112.09 286.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 291.13 112.09 294.47 133.05 282.37 133.05 279.03 112.09 291.13",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 291.13 133.05 279.03 133.7 281.11 112.74 293.21 112.09 291.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 295.52 112.09 298.85 133.05 286.75 133.05 283.41 112.09 295.52",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 295.52 133.05 283.41 133.7 285.49 112.74 297.59 112.09 295.52",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 299.9 112.09 303.24 133.05 291.13 133.05 287.8 112.09 299.9",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 299.9 133.05 287.8 133.7 289.87 112.74 301.98 112.09 299.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,190.76a1,1,0,0,0-1,.1l-4,2.32a3.27,3.27,0,0,0-1.49,2.58v20.76a1,1,0,0,0,.42.94l1.07.61a1,1,0,0,0,1-.1l4-2.31a3.28,3.28,0,0,0,1.49-2.58V192.31a1,1,0,0,0-.41-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,191.45l-4,2.32a3.27,3.27,0,0,0-1.49,2.58v20.76c0,.95.66,1.34,1.49.86l4-2.31a3.28,3.28,0,0,0,1.49-2.58V192.31C138.87,191.36,138.21,191,137.38,191.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.75,193.2,134,194.79a2.22,2.22,0,0,0-1,1.77v14.22c0,.65.45.92,1,.59l2.74-1.58a2.25,2.25,0,0,0,1-1.77V193.79C137.77,193.14,137.32,192.88,136.75,193.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,193.36a1.37,1.37,0,0,0,0-.23,1,1,0,0,0-.23.07L134,194.79a2.22,2.22,0,0,0-1,1.77v14.22a.86.86,0,0,0,0,.24,1.43,1.43,0,0,0,.22-.08l2.75-1.59a2.24,2.24,0,0,0,1-1.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.52 355.14 21.57 339 21.57 137.28 49.52 153.42 49.52 355.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.52 153.42 98.44 125.18 98.44 326.9 49.52 355.14 49.52 153.42",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.68,347.06a.84.84,0,0,1-.43-.11.87.87,0,0,1-.43-.75V156.4a.86.86,0,0,1,.43-.74l38.59-22.29a.9.9,0,0,1,.87,0,.89.89,0,0,1,.43.75v189.8a.89.89,0,0,1-.43.75L55.11,347A.81.81,0,0,1,54.68,347.06Zm.86-190.16V344.71l36.88-21.29V135.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.44 125.18 70.48 109.04 21.57 137.28 49.52 153.42 98.44 125.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.48,158.61l11-6.34c.82-.48,1.49-.09,1.49.86v4.62a3.33,3.33,0,0,1-1.49,2.59l-11,6.34c-.82.48-1.49.09-1.49-.86V161.2A3.33,3.33,0,0,1,68.48,158.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,167.22a1.09,1.09,0,0,1-.56-.15,1.34,1.34,0,0,1-.6-1.25V161.2a3.59,3.59,0,0,1,1.66-2.87l11-6.35a1.24,1.24,0,0,1,2,1.15v4.62a3.61,3.61,0,0,1-1.66,2.87l-11,6.35A1.65,1.65,0,0,1,67.82,167.22Zm12.32-14.83a1.11,1.11,0,0,0-.5.16l-11,6.35a3,3,0,0,0-1.33,2.3v4.62a.75.75,0,0,0,.27.68.78.78,0,0,0,.73-.1l11-6.35a3,3,0,0,0,1.33-2.3v-4.62a.75.75,0,0,0-.27-.68A.44.44,0,0,0,80.14,152.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 177.82 63.17 181.15 84.14 169.05 84.14 165.71 63.17 177.82",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 177.82 84.14 165.71 84.79 167.79 63.82 179.89 63.17 177.82",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 182.2 63.17 185.54 84.14 173.43 84.14 170.1 63.17 182.2",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 182.2 84.14 170.1 84.79 172.17 63.82 184.28 63.17 182.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 186.58 63.17 189.92 84.14 177.82 84.14 174.48 63.17 186.58",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 186.58 84.14 174.48 84.79 176.56 63.82 188.66 63.17 186.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 190.97 63.17 194.3 84.14 182.2 84.14 178.86 63.17 190.97",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 190.97 84.14 178.86 84.79 180.94 63.82 193.04 63.17 190.97",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 314.99 63.17 318.33 84.14 306.22 84.14 302.89 63.17 314.99",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 314.99 84.14 302.89 84.79 304.96 63.82 317.07 63.17 314.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 319.37 63.17 322.71 84.14 310.61 84.14 307.27 63.17 319.37",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 319.37 84.14 307.27 84.79 309.35 63.82 321.45 63.17 319.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 323.76 63.17 327.09 84.14 314.99 84.14 311.65 63.17 323.76",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 323.76 84.14 311.65 84.79 313.73 63.82 325.83 63.17 323.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 328.14 63.17 331.48 84.14 319.37 84.14 316.04 63.17 328.14",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 328.14 84.14 316.04 84.79 318.11 63.82 330.22 63.17 328.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47,219a1,1,0,0,0-1,.1l-4,2.32A3.29,3.29,0,0,0,82,224v20.76a1,1,0,0,0,.43.94l1.07.62a1,1,0,0,0,1-.11l4-2.31A3.31,3.31,0,0,0,90,241.32V220.55a1,1,0,0,0-.42-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47,219.69l-4,2.32A3.29,3.29,0,0,0,83,224.59v20.76c0,1,.67,1.34,1.49.86l4-2.31A3.31,3.31,0,0,0,90,241.32V220.55C90,219.6,89.29,219.22,88.47,219.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.84,221.44,85.09,223a2.26,2.26,0,0,0-1,1.77V239c0,.66.46.92,1,.59L87.84,238a2.28,2.28,0,0,0,1-1.77V222C88.86,221.38,88.4,221.12,87.84,221.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.11,221.6a.78.78,0,0,0,0-.23,1.11,1.11,0,0,0-.22.07L85.09,223a2.26,2.26,0,0,0-1,1.77V239a.85.85,0,0,0,.05.24,1.19,1.19,0,0,0,.22-.08l2.75-1.59a2.24,2.24,0,0,0,1-1.76Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lockers--inject-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.65 298.66 380.6 282.52 380.6 80.8 352.65 96.94 352.65 298.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.65 96.94 303.74 68.7 303.73 270.42 352.65 298.66 352.65 96.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.06,290.47l-38.59-22.29a.84.84,0,0,1-.43-.74V77.64a.86.86,0,0,1,.43-.75.88.88,0,0,1,.86,0l38.59,22.28a.89.89,0,0,1,.43.75v189.8a.89.89,0,0,1-.43.75.9.9,0,0,1-.86,0ZM309.76,79.13V266.94l36.87,21.29V100.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.74 68.7 331.69 52.56 380.6 80.8 352.65 96.94 303.74 68.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.69,102.13l-11-6.35c-.82-.47-1.49-.09-1.49.86v4.63a3.29,3.29,0,0,0,1.49,2.58l11,6.35c.82.48,1.49.09,1.49-.86v-4.63A3.31,3.31,0,0,0,333.69,102.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.36,110.74a1.76,1.76,0,0,1-.84-.25l-11-6.35a3.62,3.62,0,0,1-1.66-2.87V96.65a1.23,1.23,0,0,1,2-1.15l11,6.35a3.59,3.59,0,0,1,1.66,2.86v4.63a1.35,1.35,0,0,1-.6,1.25A1.08,1.08,0,0,1,334.36,110.74ZM322,95.91a.38.38,0,0,0-.22.06c-.18.1-.27.34-.27.68v4.62a3,3,0,0,0,1.32,2.3l11,6.35a.78.78,0,0,0,.73.1.76.76,0,0,0,.27-.68v-4.63a3,3,0,0,0-1.33-2.29l-11-6.35A1.11,1.11,0,0,0,322,95.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 121.33 339 124.67 318.04 112.57 318.04 109.23 339 121.33",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 121.33 318.04 109.23 317.38 111.31 338.35 123.41 339 121.33",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 125.72 339 129.05 318.04 116.95 318.04 113.61 339 125.72",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 125.72 318.04 113.61 317.38 115.69 338.35 127.79 339 125.72",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 130.1 339 133.44 318.04 121.33 318.04 118 339 130.1",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 130.1 318.04 118 317.38 120.07 338.35 132.18 339 130.1",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 134.49 339 137.82 318.04 125.72 318.04 122.38 339 134.49",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 134.49 318.04 122.38 317.38 124.46 338.35 136.56 339 134.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 258.51 339 261.85 318.04 249.74 318.04 246.41 339 258.51",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 258.51 318.04 246.41 317.38 248.48 338.35 260.58 339 258.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 262.89 339 266.23 318.04 254.13 318.04 250.79 339 262.89",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 262.89 318.04 250.79 317.38 252.87 338.35 264.97 339 262.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 267.28 339 270.61 318.04 258.51 318.04 255.17 339 267.28",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 267.28 318.04 255.17 317.38 257.25 338.35 269.35 339 267.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 271.66 339 275 318.04 262.89 318.04 259.56 339 271.66",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339 271.66 318.04 259.56 317.38 261.63 338.35 273.74 339 271.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,162.52a1,1,0,0,1,1,.1l4,2.32a3.29,3.29,0,0,1,1.49,2.58v20.76a1,1,0,0,1-.43.94l-1.07.61a1,1,0,0,1-1-.1l-4-2.31a3.31,3.31,0,0,1-1.49-2.58V164.07a1,1,0,0,1,.42-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,163.21l4,2.31a3.33,3.33,0,0,1,1.49,2.59v20.76c0,.95-.67,1.34-1.49.86l-4-2.31a3.31,3.31,0,0,1-1.49-2.58V164.07C312.21,163.12,312.88,162.74,313.7,163.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.33,165l2.75,1.59a2.25,2.25,0,0,1,1,1.77v14.22c0,.65-.46.92-1,.59l-2.75-1.58a2.28,2.28,0,0,1-1-1.77V165.55C313.31,164.9,313.77,164.64,314.33,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.06,165.12a.93.93,0,0,1,.05-.24c.07,0,.14,0,.22.08l2.75,1.59a2.25,2.25,0,0,1,1,1.77v14.22a.78.78,0,0,1-.05.23,1.11,1.11,0,0,1-.22-.07l-2.75-1.59a2.25,2.25,0,0,1-1-1.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.56 326.9 429.51 310.76 429.51 109.04 401.56 125.18 401.56 326.9",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.56 125.18 352.65 96.94 352.65 298.66 401.56 326.9 401.56 125.18",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,318.71l-38.59-22.29a.84.84,0,0,1-.43-.74V105.88a.86.86,0,0,1,.43-.75.88.88,0,0,1,.86,0l38.59,22.29a.84.84,0,0,1,.43.74V318a.86.86,0,0,1-.43.75.92.92,0,0,1-.43.11A1,1,0,0,1,396,318.71Zm-37.3-211.34V295.18l36.87,21.29V128.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.65 96.94 380.6 80.8 429.51 109.04 401.56 125.18 352.65 96.94",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.6,130.37l-11-6.34c-.82-.48-1.49-.09-1.49.86v4.62a3.29,3.29,0,0,0,1.49,2.58l11,6.35c.83.48,1.49.09,1.49-.86V133A3.28,3.28,0,0,0,382.6,130.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.27,139a1.65,1.65,0,0,1-.83-.25l-11-6.35a3.6,3.6,0,0,1-1.65-2.87v-4.62a1.23,1.23,0,0,1,2-1.15l11,6.35h0a3.58,3.58,0,0,1,1.65,2.86v4.63a1.34,1.34,0,0,1-.6,1.25A1,1,0,0,1,383.27,139Zm-12.33-14.83a.4.4,0,0,0-.22.06.75.75,0,0,0-.27.68v4.62a3,3,0,0,0,1.32,2.3l11,6.35a.59.59,0,0,0,1-.58V133a3,3,0,0,0-1.32-2.29h0l-11-6.35A1.08,1.08,0,0,0,370.94,124.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 149.57 387.91 152.91 366.95 140.81 366.95 137.47 387.91 149.57",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 149.57 366.95 137.47 366.3 139.55 387.26 151.65 387.91 149.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 153.96 387.91 157.29 366.95 145.19 366.95 141.85 387.91 153.96",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 153.96 366.95 141.85 366.3 143.93 387.26 156.03 387.91 153.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 158.34 387.91 161.68 366.95 149.57 366.95 146.24 387.91 158.34",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 158.34 366.95 146.24 366.3 148.31 387.26 160.42 387.91 158.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 162.73 387.91 166.06 366.95 153.96 366.95 150.62 387.91 162.73",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 162.73 366.95 150.62 366.3 152.7 387.26 164.8 387.91 162.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 286.75 387.91 290.09 366.95 277.98 366.95 274.65 387.91 286.75",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 286.75 366.95 274.65 366.3 276.72 387.26 288.83 387.91 286.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 291.13 387.91 294.47 366.95 282.37 366.95 279.03 387.91 291.13",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 291.13 366.95 279.03 366.3 281.11 387.26 293.21 387.91 291.13",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 295.52 387.91 298.85 366.95 286.75 366.95 283.41 387.91 295.52",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 295.52 366.95 283.41 366.3 285.49 387.26 297.59 387.91 295.52",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 299.9 387.91 303.24 366.95 291.13 366.95 287.8 387.91 299.9",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.91 299.9 366.95 287.8 366.3 289.87 387.26 301.98 387.91 299.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.62,190.76a1,1,0,0,1,1,.1l4,2.32a3.27,3.27,0,0,1,1.49,2.58v20.76a1,1,0,0,1-.42.94l-1.07.61a1,1,0,0,1-1-.1l-4-2.31a3.28,3.28,0,0,1-1.49-2.58V192.31a1,1,0,0,1,.41-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.62,191.45l4,2.32a3.27,3.27,0,0,1,1.49,2.58v20.76c0,.95-.66,1.34-1.49.86l-4-2.31a3.28,3.28,0,0,1-1.49-2.58V192.31C361.13,191.36,361.79,191,362.62,191.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.25,193.2l2.74,1.59a2.22,2.22,0,0,1,1,1.77v14.22c0,.65-.45.92-1,.59l-2.74-1.58a2.25,2.25,0,0,1-1-1.77V193.79C362.23,193.14,362.68,192.88,363.25,193.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,193.36a1.37,1.37,0,0,1,0-.23,1,1,0,0,1,.23.07l2.74,1.59a2.22,2.22,0,0,1,1,1.77v14.22a.86.86,0,0,1,0,.24,1.43,1.43,0,0,1-.22-.08L364,209.35a2.24,2.24,0,0,1-1-1.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.48 355.14 478.43 339 478.43 137.28 450.48 153.42 450.48 355.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.48 153.42 401.56 125.18 401.56 326.9 450.48 355.14 450.48 153.42",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.89,347l-38.6-22.28a.89.89,0,0,1-.43-.75V134.12a.89.89,0,0,1,.43-.75.9.9,0,0,1,.87,0l38.59,22.29a.86.86,0,0,1,.43.74V346.2a.87.87,0,0,1-.43.75.84.84,0,0,1-.43.11A.81.81,0,0,1,444.89,347ZM407.58,135.61V323.42l36.88,21.29V156.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.56 125.18 429.51 109.04 478.43 137.28 450.48 153.42 401.56 125.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.52,158.61l-11-6.34c-.82-.48-1.49-.09-1.49.86v4.62a3.33,3.33,0,0,0,1.49,2.59l11,6.34c.82.48,1.49.09,1.49-.86V161.2A3.33,3.33,0,0,0,431.52,158.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.18,167.22a1.65,1.65,0,0,1-.83-.25l-11-6.35a3.61,3.61,0,0,1-1.66-2.87v-4.62a1.24,1.24,0,0,1,2-1.15l11,6.35a3.59,3.59,0,0,1,1.66,2.87v4.62a1.34,1.34,0,0,1-.6,1.25A1.09,1.09,0,0,1,432.18,167.22Zm-12.32-14.83a.44.44,0,0,0-.23.06.75.75,0,0,0-.27.68v4.62a3,3,0,0,0,1.33,2.3l11,6.35a.78.78,0,0,0,.73.1.75.75,0,0,0,.27-.68V161.2a3,3,0,0,0-1.33-2.3h0l-11-6.35A1.15,1.15,0,0,0,419.86,152.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 177.82 436.83 181.15 415.87 169.05 415.87 165.71 436.83 177.82",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 177.82 415.87 165.71 415.21 167.79 436.18 179.89 436.83 177.82",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 182.2 436.83 185.54 415.87 173.43 415.87 170.1 436.83 182.2",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 182.2 415.87 170.1 415.21 172.17 436.18 184.28 436.83 182.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 186.58 436.83 189.92 415.87 177.82 415.87 174.48 436.83 186.58",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 186.58 415.87 174.48 415.21 176.56 436.18 188.66 436.83 186.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 190.97 436.83 194.3 415.87 182.2 415.87 178.86 436.83 190.97",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 190.97 415.87 178.86 415.21 180.94 436.18 193.04 436.83 190.97",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 314.99 436.83 318.33 415.87 306.22 415.87 302.89 436.83 314.99",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 314.99 415.87 302.89 415.21 304.96 436.18 317.07 436.83 314.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 319.37 436.83 322.71 415.87 310.61 415.87 307.27 436.83 319.37",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 319.37 415.87 307.27 415.21 309.35 436.18 321.45 436.83 319.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 323.76 436.83 327.09 415.87 314.99 415.87 311.65 436.83 323.76",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 323.76 415.87 311.65 415.21 313.73 436.18 325.83 436.83 323.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 328.14 436.83 331.48 415.87 319.37 415.87 316.04 436.83 328.14",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 328.14 415.87 316.04 415.21 318.11 436.18 330.22 436.83 328.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53,219a1,1,0,0,1,1,.1l4,2.32a3.29,3.29,0,0,1,1.49,2.58v20.76a1,1,0,0,1-.43.94l-1.07.62a1,1,0,0,1-1-.11l-4-2.31a3.31,3.31,0,0,1-1.49-2.58V220.55a1,1,0,0,1,.42-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53,219.69l4,2.32a3.29,3.29,0,0,1,1.49,2.58v20.76c0,1-.67,1.34-1.49.86l-4-2.31a3.31,3.31,0,0,1-1.49-2.58V220.55C410,219.6,410.71,219.22,411.53,219.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,221.44l2.75,1.59a2.26,2.26,0,0,1,1,1.77V239c0,.66-.46.92-1,.59L412.16,238a2.28,2.28,0,0,1-1-1.77V222C411.14,221.38,411.6,221.12,412.16,221.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.89,221.6a.78.78,0,0,1,.05-.23,1.11,1.11,0,0,1,.22.07l2.75,1.59a2.26,2.26,0,0,1,1,1.77V239a.85.85,0,0,1-.05.24,1.19,1.19,0,0,1-.22-.08l-2.75-1.59a2.24,2.24,0,0,1-1-1.76Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Backpack--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.22,177.34l-13.11-5.21-1.24-16.19s8.22,2.28,9.95,5.08C351.61,165.52,353.71,172,353.22,177.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.22,177.34l-13.11-5.21-1.24-16.19s8.22,2.28,9.95,5.08C351.61,165.52,353.71,172,353.22,177.34Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.76,150.42c-3.71.26-8.13,3.33-9.05,4.89-1.7,2.86-4,38.89-.56,42.43,4.36,4.46,24.6,12.18,33.1,11.18a16.06,16.06,0,0,0,12-7.83c1.49-3.23-5.4-35.23-7.93-38.58C343.25,157.08,324.47,150.1,319.76,150.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.76,150.42c-3.71.26-8.13,3.33-9.05,4.89-1.7,2.86-4,38.89-.56,42.43,4.36,4.46,24.6,12.18,33.1,11.18a16.06,16.06,0,0,0,12-7.83c1.49-3.23-5.76-36.25-8.29-39.6C342.89,156.07,324.47,150.1,319.76,150.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,187.53a162.54,162.54,0,0,1-1-23.5c-.27-2.31,2-7,2-7a19,19,0,0,1,6,4.43c2.53,3.35,9.78,36.36,8.29,39.6h0l-.17.33,0,0c-.07.12-.14.24-.22.36l0,.06-.27.4,0,.05c-.1.15-.22.3-.34.46h0c-.26.33-.56.68-.89,1h0l-.53.53h0a16.59,16.59,0,0,1-7.37,4.15C341,208.15,341.16,198.26,339.93,187.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,164c-.27-2.31,2-7,2-7a19,19,0,0,1,6,4.43c.08.12.17.26.27.44a6.79,6.79,0,0,1-1.94,2.93,25.92,25.92,0,0,1-6.45,3.82C338.89,165.76,339,164,339,164Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.71,183.8c-.16-.07-2.6-1.57-2.87-1.68-.49-.2-6.84,5-7.4,5.83-.38.58,1.66,14.55,2,15.12.11.21,2.76,1.48,2.87,1.68.32.57,7-4.72,7.39-5.89S352.43,184.08,351.71,183.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.71,183.8c-.16-.07-2.6-1.57-2.87-1.68-.49-.2-6.84,5-7.4,5.83-.38.58,1.66,14.55,2,15.12.11.21,2.76,1.48,2.87,1.68.32.57,7-4.72,7.39-5.89S352.43,184.08,351.71,183.8Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.32,189.63c-.39.58,1.65,14.55,2,15.12s7-4.72,7.39-5.89-1.25-14.78-2-15.06C351.22,183.6,344.87,188.79,344.32,189.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.84,182.12c.27.11,2.71,1.62,2.87,1.68-.49-.19-6.84,5-7.39,5.82L341.44,188C342,187.11,348.35,181.92,348.84,182.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.32,189.63c-.39.58,1.65,14.55,2,15.12s7-4.72,7.39-5.89-1.25-14.78-2-15.06C351.22,183.6,344.87,188.79,344.32,189.63Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,188c.48-.38,2.06.29,2.76.79s1.64,3,3.36,3.31,3.88-2.17,4.25-3.64.68-4.51-.23-5.5a2.76,2.76,0,0,0-3.51-.69C346.94,183,341.47,186.63,341.44,188Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,188c.48-.38,2.06.29,2.76.79s1.64,3,3.36,3.31,3.88-2.17,4.25-3.64.68-4.51-.23-5.5a2.76,2.76,0,0,0-3.51-.69C346.94,183,341.47,186.63,341.44,188Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.11,188.41a1.25,1.25,0,0,0-.48,1.21.5.5,0,0,0,.81.37,1.21,1.21,0,0,0,.47-1.21C349.82,188.34,349.46,188.17,349.11,188.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,168.68s-.55-1.37,5-5.41c3.68-2.66,4.1-2.08,5.84,1.34,1,1.94,2,4.34,3.47,12.73.74-.08,1.11-2.39,0-7.39-1.79-7.73-4-11.73-8.21-13.81-10.79-5.31-18.08-7.25-24.85-6.1-6.33,1.07-10.42,3.3-10.26,9C309.86,159,318.8,169.21,338.88,168.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,168.68s-.55-1.37,5-5.41c3.68-2.66,4.1-2.08,5.84,1.34,1,1.94,2,4.34,3.47,12.73.74-.08,1.11-2.39,0-7.39-1.79-7.73-4-11.73-8.21-13.81-10.79-5.31-18.08-7.25-24.85-6.1-6.33,1.07-10.42,3.3-10.26,9C309.86,159,318.8,169.21,338.88,168.68Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69,328.09c-.87-9.72-.06-13.81-1.1-29h0c-.13-3.89-.33-8.06-.65-11.77-1.09-12.45-3.18-16.7-3.4-19.1,0,0,0-15-1.19-42.22-.56-12.83-4.55-16.68-7.78-23.46l-39.7.42c-2.1,17-2,48.49-1.64,65.81.17,8.84,4.44,52.7,4.53,53.79.32,3.85,0,5.38-1.6,7-3.31,3.43-8.13,6.71-12.29,9.72.63,1.51,5.68,1.4,8.16.22a66,66,0,0,0,9.26-5.71c3.42-2.45,7.8-4.43,7.81-8.11a4.91,4.91,0,0,1,.11-.65c0-2.15,5-30.47,5.38-37.81a164.75,164.75,0,0,0-.65-17l3.55-21.75s2.25,11.32,5.07,22.07c2.3,8.75,6.34,20.31,8.94,31.08h0c2.52,12.42,6.1,21.24,6.78,27.46.2,1.48,2.17,16.06,3,19.4s8.49,3.34,8.92-2.42C349.43,342.26,347.85,329.92,347.69,328.09Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.77,343.26a3,3,0,0,0,.63,3.17c1.34,1.09,5.27,2.88,10.46,2.24s8-2.15,10.09-3.8,5-4,7.33-4.45a14.54,14.54,0,0,0,5.25-2c.7-.63.6-3.47.6-3.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.31,324s.39,0,.52.67.34,3.05.68,4.33a21.46,21.46,0,0,1,.52,6.88c-.28,1.45-3.84,2.46-6.11,3.28a29.12,29.12,0,0,0-7.36,4.39,22.12,22.12,0,0,1-11,3.86c-5.17.08-8.52-1.25-9.55-3-1.28-2.17-.28-3.43,5.65-6,1.13-.49,5.07-2.7,6.42-3.5a29.94,29.94,0,0,0,4-2.84,22.33,22.33,0,0,0,1.81-1.7,7.57,7.57,0,0,0,1.5-1.81,4.43,4.43,0,0,0,.17-.47,7.1,7.1,0,0,0,.39-1.32c.1-.47.15-1.15.62-1.42a4,4,0,0,1,2.13-.24,15.94,15.94,0,0,1,2.29.3c.87.19,1.88.26,2.4,1a3.92,3.92,0,0,1,.49,2c0,.32,0,.65,0,1,0,.14-.07.39.14.33s.42-.54.49-.71c.17-.36.27-.76.45-1.12a6,6,0,0,1,.74-1.18,5.78,5.78,0,0,1,.94-.91,11.53,11.53,0,0,0,1-.62A2.19,2.19,0,0,0,308.31,324Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.75,338.83c7.48.49,9.84,4.85,10.16,7.55a18.45,18.45,0,0,1-5.31,1.05c-5.17.08-8.73-1.24-9.76-3C274.63,342.39,275.44,340.74,280.75,338.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,338.9a.36.36,0,0,0,.23-.08.33.33,0,0,0,.06-.48,9.07,9.07,0,0,0-6.77-2.52.36.36,0,0,0-.33.38.37.37,0,0,0,.41.31,8.41,8.41,0,0,1,6.12,2.26A.35.35,0,0,0,292,338.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.18,337.12a.4.4,0,0,0,.24-.07.35.35,0,0,0,.05-.49,9.06,9.06,0,0,0-6.77-2.51.36.36,0,0,0-.33.38.37.37,0,0,0,.41.3A8.36,8.36,0,0,1,294.9,337,.38.38,0,0,0,295.18,337.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.17,335.1a.4.4,0,0,0,.23-.08.33.33,0,0,0,.05-.49,9.1,9.1,0,0,0-6.77-2.51.34.34,0,1,0,.08.68,8.42,8.42,0,0,1,6.12,2.27A.41.41,0,0,0,298.17,335.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.09,333.07a.39.39,0,0,0,.23-.07.34.34,0,0,0,.06-.49c-1.44-1.71-4.68-2.83-7.39-2.55a.35.35,0,0,0-.33.38.37.37,0,0,0,.4.31c2.45-.25,5.47.78,6.74,2.29A.37.37,0,0,0,301.09,333.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.83,351.14c.25,3.33.83,5.53,2.1,7.47s3.65,2.53,6,1.93,5.43-2.16,6.07-5a17.23,17.23,0,0,0,.45-7.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59,326.9c1,.06,1.33,4.54,2,9,.67,4.79,2.21,6.76,2.8,10.69.68,4.5-.08,6.51-1.72,9.25s-7.51,5.47-10.47,1.6c-2.41-3.15-2.55-6.67-2.39-11.16a96.76,96.76,0,0,0-.46-11.38c-.24-3.36-1.07-6.75-.22-7.13.08.49.15,1.12.22,1.6a8.21,8.21,0,0,0,.34,1.79c.11.25.33.51.41.11a2.37,2.37,0,0,0,0-.84c-.16-1.24.5-1.35.86-1.45a46.15,46.15,0,0,1,4.57-.66c.75-.06,3.35-.19,3.69.21a2.7,2.7,0,0,1,.35,1.3c.09.67.26,1.17.28,1,0-.49-.08-1.75-.09-2.05s-.07-.69-.08-1S347.61,327.19,347.59,326.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.66,349.21a10.74,10.74,0,0,1-1.76,6.85c-1.63,2.74-8,5.48-10.95,1.62a12.22,12.22,0,0,1-2.11-6.55C339.54,348.11,349.87,346.68,352.66,349.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,346.22l.12,0a17.63,17.63,0,0,1,9-.93.36.36,0,0,0,.43-.26.34.34,0,0,0-.28-.41,18.15,18.15,0,0,0-9.51,1,.33.33,0,0,0-.16.46A.37.37,0,0,0,339.93,346.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.81,341.91a.36.36,0,0,0,.31-.23.35.35,0,0,0-.23-.44c-4.44-1.36-9.32.81-9.5.9a.33.33,0,0,0-.15.47.38.38,0,0,0,.5.14s4.79-2.13,8.92-.85A.26.26,0,0,0,348.81,341.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.62,338.75a.35.35,0,0,0,.3-.22.33.33,0,0,0-.22-.44A13.57,13.57,0,0,0,339,339a.35.35,0,0,0-.12.48.39.39,0,0,0,.51.11,13,13,0,0,1,9-.81A.29.29,0,0,0,348.62,338.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.34,335.65a.38.38,0,0,0,.3-.23.34.34,0,0,0-.22-.44c-4.57-1.56-9.55.87-9.74,1a.34.34,0,0,0-.13.47.36.36,0,0,0,.5.12s4.88-2.36,9.12-.91A.5.5,0,0,0,348.34,335.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,202.64c4.53,7.58,4.74,13.8,5.47,36.49s.13,24.59.26,27.33,1.87,7.6,3.52,21.07a132.31,132.31,0,0,1,.35,26.15s-1,2.18-6.45,2.7c-5,.48-7.54-1.28-7.54-1.28s-7.48-22.79-9.49-30.88-7.29-30.29-7.29-30.29L314,270.6s1.62,7.42.24,19.26a167.55,167.55,0,0,1-3.63,20.44,25,25,0,0,1-8.13,1.46,13.89,13.89,0,0,1-7-1.79s-4.39-31.59-4.56-45-1.14-52,3.65-69.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.88,268.92s-2.8-2.7-8.11-2-7.45,3.64-7.45,3.64C328,268,337.88,268.92,337.88,268.92Zm-12.49,2.55c3.13.55,6.27.78,13.12-.57C335.24,270.18,325.39,271.47,325.39,271.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,268.77c-2-1-9.28-2.37-13.86-1.74l.06,1.45A71.47,71.47,0,0,1,304.77,268.77Zm-13.69,1.59.09,1.37a78.37,78.37,0,0,0,10.37-1.24C296.3,270.16,291.08,270.36,291.08,270.36Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.33,276.94c-.19-.77-.37-1.51-.53-2.21-1.47-6.25-.95-10-1.06-20.39,0-3.13-.06-6.37-.14-9.82-.29-13.51-1.63-33-9-42.68l-.58.39c5,6.51,7.16,19.93,8.12,29.29C332,230.7,330.3,224,328,214.81c-.31-1.26-2.52-11-2.86-12.34l-.7.16c.35,1.34,2.56,11.07,2.87,12.33,2.25,9.18,4,16.46,11.87,17.26.4,4.12.58,8.29.67,12.31.07,3.45.11,6.69.14,9.82.11,10.42-.41,14.2,1.07,20.52q.25,1.06.54,2.22c2,8.09,5.15,16.84,4,38a5.31,5.31,0,0,0,.74-.46C347.46,293.68,344.29,285,342.33,276.94Zm-43.11-58.42c1,4.45,6.57,6.86,10,7.6l.68,2.87c-.14,2.42-.29,11.87-.44,14.49-.87,14.42-1.33,24.32-.51,27.68,2.17,8.83,1.63,14.44.66,24.64-.1,1.05-.21,2.14-.31,3.28-.55,5.92-1.27,8.39-1.68,12.12l.74-.17c.41-3.74,1.11-6.09,1.65-11.89.1-1.14.21-2.23.31-3.28,1-10.26,1.52-15.92-.67-24.85-.8-3.26-.3-13.79.52-27.49.1-1.66.19-10.22.29-11.8l3.25,22.86.26,16,2.59-16.67-4.83-30.56A18.55,18.55,0,0,1,299.22,218.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.6,188.73c-2.32.89-3.7.31-5.17,0-2.32-.45-3.46-.84-4.79-.25s-1.56,1.29-2.64,1.52a57.38,57.38,0,0,0-5.85,1.71,2.29,2.29,0,0,0-.61,3.24c-1.12-.07-1.78,1.88-.17,3.69-1,.18-1.26,2.12-.2,3.25-.44.66-.22,1.64.8,2.41a15.56,15.56,0,0,0,3.14,1.75c.75.33,1.45.14,2.63-.36a11.23,11.23,0,0,0,2.25-1.18c.87.15,2.93.71,7-1.85a24.53,24.53,0,0,1,6.42-2.93S279.15,190.63,274.6,188.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.43,196.79a10.3,10.3,0,0,1-1.81-.49,4.31,4.31,0,0,1-.83-.42,1.51,1.51,0,0,1-.5-.59,1,1,0,0,1-.09-.21,7.3,7.3,0,0,0-.41-.9,1.76,1.76,0,0,0-.83-.81,1.67,1.67,0,0,1,.87,1.32,10.42,10.42,0,0,1,.28,1.82,5.09,5.09,0,0,1-.26,1.78,1.81,1.81,0,0,1-.86,1.09l-.07,0a1.41,1.41,0,0,1-1.72-.91c-.65-1.44-1.36-2.83-1.91-4.29-.87-1.89,0-2.7,1.22-4-1.3,1.22-2.16,2.08-1.52,3.84l-.16-.13a2.13,2.13,0,0,0-.54-.28,1,1,0,0,0-.48-.09s0,.06,0,.08.31.09.46.16a2.51,2.51,0,0,1,.78.68l.11.18.1.12c.46,1.19,1,2.33,1.51,3.48-1.33-.11-2.83.24-4-.35a4.57,4.57,0,0,1-.81-.67c-.77-.71-1.63-1.48-2.38-2.2a19.51,19.51,0,0,0,3.06,3.1c1.34.62,2.78.22,4.18.14l.17.38a1.88,1.88,0,0,0,.82.94,1.48,1.48,0,0,0,.46.16c-1.43.39-3,1.38-4.43,1-1.46-.64-2.94-1.44-4.43-2.06a47.77,47.77,0,0,0,4.36,2.31c1.49.34,2.87-.53,4.21-1.13a2.28,2.28,0,0,1,1.52.74c.66,1.14-2.92,2.63-3.77,3a3.51,3.51,0,0,1-3.31-.17,34.57,34.57,0,0,1-3.21-1.49,23,23,0,0,0,3.13,1.68,5.76,5.76,0,0,0,1.71.58,4,4,0,0,0,1.78-.35,17,17,0,0,0,2.76-1.46c.67.63-.05,1.61-.56,2.17.82-.4,1.46-1.74.59-2.19.81-.57,1.36-1.23,1-1.84a2.4,2.4,0,0,0-1.63-.66l.34-.14a1.52,1.52,0,0,0,1.61-.93,5.12,5.12,0,0,0,.46-2.91A6.79,6.79,0,0,0,269.43,196.79Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,166.42l.24-14.68c-7.25,0-10.79,1.45-15.58,11.79-4.06,8.77-9,20.47-9,20.47s-6.84,3.46-11,5.09l2.6,11c2.22-.67,4.43-1.33,12.06-3.49,7.35-2.08,9.31-4.28,11.57-7.13,2.63-3.32,3.09-6.58,4.62-11.1A119.12,119.12,0,0,1,309,166.42Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.13,178.51s-3.75-1.29-5.62-8.87c-.85-3.45-.18-8.15.69-13.58l-10.57-3.19s-3.43-.53-10.93-1l-4.44-.13s-13.83,7.59-18.06,14.7c-1.71,2.87-2.53,8.62,1.8,15.8.24,5.21-.32,17.51-.32,17.51s6.78,6.42,20.48,6.37c19.65-.08,22.88-7.79,22.88-7.79C335.77,192.74,338.71,184.09,340.13,178.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.13,178.51s-3.75-1.29-5.62-8.87c-.85-3.45-.18-8.15.69-13.58l-10.57-3.19s-3.43-.53-10.93-1l-4.44-.13s-13.83,7.59-18.06,14.7c-1.71,2.87-2.53,8.62,1.8,15.8.24,5.21-.32,17.51-.32,17.51s6.78,6.42,20.48,6.37c19.65-.08,22.88-7.79,22.88-7.79C335.77,192.74,338.71,184.09,340.13,178.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.9,183.58s3.35,4.41,10.84,3.34,9.08-6.65,9.08-6.65.27,7.25-8.67,8.48S306.9,183.58,306.9,183.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.42,153.68s-3.62,4.73-4.38,15.66C321.75,188,336.81,197,336.81,197a86.51,86.51,0,0,0,.23-9.15s-6.94-7.35-6.19-14.87c1-10,2.77-14.53,4.32-16.87C335.17,156.06,330.87,153.79,327.42,153.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.42,153.68s-3.62,4.73-4.38,15.66C321.75,188,336.81,197,336.81,197a86.51,86.51,0,0,0,.23-9.15s-6.94-7.35-6.19-14.87c1-10,2.77-14.53,4.32-16.87C335.17,156.06,330.87,153.79,327.42,153.68Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.68,169.41a.37.37,0,0,1,.35-.07l13.06,2.35a1.82,1.82,0,0,1,1,.68l14.29,21.15c.11.17.13.3.06.38s-1.09,1.3-1.16,1.38-.18.09-.35.06L289.92,193a1.86,1.86,0,0,1-1.05-.68l-14.29-21.15c-.11-.17-.13-.3-.06-.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.49,173.31a1.71,1.71,0,0,1,.48.44l14.29,21.15c.11.16.12.28.07.36.12-.13,1.1-1.3,1.15-1.36s0-.21-.06-.38l-14.29-21.15a1.58,1.58,0,0,0-.48-.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,195.34,289.92,193a1.86,1.86,0,0,1-1.05-.68l-14.29-21.15c-.21-.31-.08-.51.29-.45l13.05,2.35a1.81,1.81,0,0,1,1.05.68l14.29,21.15C303.47,195.21,303.34,195.41,303,195.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.88,177.55l-1.46-2.15a2.11,2.11,0,0,0-1.2-.78l-.51-.09c-.67-.12-.9.24-.52.8l1.45,2.16a2.17,2.17,0,0,0,1.2.78l.51.09C290,178.48,290.26,178.12,289.88,177.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.33,177.38a2,2,0,0,0-1.13-.71c-.41-.07-.58.12-.36.44a2,2,0,0,0,1.13.7C289.38,177.89,289.54,177.69,289.33,177.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,177.31a1,1,0,0,0-.58-.36c-.21,0-.29.06-.18.23a1,1,0,0,0,.58.36C289,177.57,289.07,177.47,289,177.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,175.78a2,2,0,0,0-1.13-.7c-.41-.07-.57.12-.36.44a2,2,0,0,0,1.13.7C288.29,176.3,288.45,176.1,288.23,175.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87,175.72a1,1,0,0,0-.58-.36c-.21,0-.29.06-.18.22a1,1,0,0,0,.58.36C287.9,176,288,175.88,287.87,175.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.7,175.08l.16-.19a.19.19,0,0,1,.18-.07l.26,0a.18.18,0,0,1,.13.1l1.3,1.92a.4.4,0,0,1,0,.43l-.16.18a.19.19,0,0,1-.19.08l-.25,0a.17.17,0,0,1-.13-.09l-1.3-1.92A.36.36,0,0,1,290.7,175.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,177.47l-1.29-1.92a.36.36,0,0,1,0-.43l.16-.18a.18.18,0,0,1,.32,0l1.3,1.92a.4.4,0,0,1,0,.43l-.16.18A.19.19,0,0,1,292.22,177.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.83,178.22,293,178a.2.2,0,0,1,.18-.08l.26,0a.2.2,0,0,1,.13.09l1.3,1.93a.4.4,0,0,1,0,.43l-.16.18a.21.21,0,0,1-.19.08l-.25-.05a.2.2,0,0,1-.13-.09l-1.3-1.92A.38.38,0,0,1,292.83,178.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.36,180.62l-1.3-1.92a.36.36,0,0,1,0-.43l.16-.18a.19.19,0,0,1,.32,0l1.3,1.93a.4.4,0,0,1,0,.43l-.16.18A.19.19,0,0,1,294.36,180.62Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.08,179.69l-.67-1c-.5-1.75.63-2.83,1.95-1,1.05,1.42,4.37,3.39,5.52,5.27s1.55,3.87,4.43,5.51c3.06,1.74,21.84,3.38,21.84,3.38l2.14-21s1.54-10.73,4.91-14.78c5.32,1.85,6.91,3.63,8.23,6.27,2.15,4.31,1.71,9,.26,19.11-1.37,9.63-2.4,15.38-3.66,18.95-1.56,4.42-3.54,6.52-11.55,5.45s-16.18-4.79-25-7.77c-4.25-1.43-7-2-10.36-3.87a14.08,14.08,0,0,1-3.55-2.52,8.09,8.09,0,0,1-2.15-3.32,2.66,2.66,0,0,0-.26-.68,4,4,0,0,0-.46-.56,5.09,5.09,0,0,1-.83-1.08,7.77,7.77,0,0,1-.39-1.41,4.72,4.72,0,0,0-.15-.65,3.69,3.69,0,0,0-.33-.62,5.33,5.33,0,0,1-.82-1.61.94.94,0,0,1,.27-.88s-.51-.6-.67-.81a4.87,4.87,0,0,1-.59-.95.38.38,0,0,1,.13-.61c1.16-.75,2.42-.1,3.45.55,2.69,1.69,4,3.31,6.91,4.7,4,1.91,4.2.07,4.2.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.15,191.82a19.47,19.47,0,0,1,5.75,1.41,10.53,10.53,0,0,0-5.63-2.52Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.49,181a20.36,20.36,0,0,0,1.6,1.75c.55.57,1.12,1.12,1.67,1.68.29.28.55.57.85.84s.6.53.92.77a21.83,21.83,0,0,0,1.93,1.38l-.89-.78q-.45-.37-.9-.78c-.29-.26-.59-.52-.87-.79s-.54-.56-.83-.85c-.56-.56-1.14-1.1-1.72-1.63Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.26,183.93a9.15,9.15,0,0,0,1,1.51c.38.48.79.94,1.2,1.38s.86.88,1.31,1.29a13.17,13.17,0,0,0,1.41,1.16L289,187.94l-1.25-1.32-1.25-1.33C286.05,184.85,285.64,184.41,285.26,183.93Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.1,114.54l.14.13c1.28,1.3,2.11,2.57,3.89,3.19a9.78,9.78,0,0,1,4.61,2.82,5.78,5.78,0,0,1,1.33,4.43c-.12.7-.51.91-.79,1.48a3,3,0,0,0,.15,2.36,10.76,10.76,0,0,1,1,2.63,4.92,4.92,0,0,1-2,4.09,6.11,6.11,0,0,0-1.89,2.07c-.46,1.17.07,2.49-.08,3.73-.28,2.17-2.66,3.55-4.84,3.56-1.25,0-2.62-.27-3.65.44-.78.53-1.15,1.5-1.87,2.1a4.28,4.28,0,0,1-2.57.79,9.15,9.15,0,0,1-4.44-.83,6.15,6.15,0,0,1-3.07-3.24c-.48-1.3-.44-2.75-1-4-1-2.42-3.8-3.67-4.95-6a5.2,5.2,0,0,1,0-4.66c.59-1.15,1.62-2.08,2-3.33.41-1.61-.42-3.26-.44-4.92a5.08,5.08,0,0,1,2.34-4.28c1.32-.82,2.95-1,4.31-1.75.82-.46,1.52-1.12,2.31-1.64A7.91,7.91,0,0,1,335.1,114.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,116.34a6.87,6.87,0,0,1,2.11,5.08,3.91,3.91,0,0,1-.36,1.72,3.3,3.3,0,0,1-3.45,1.51,6.13,6.13,0,0,1-3.37-2.06,8.37,8.37,0,0,1-2-3.7c-.2-.84-.46-2.38,0-3.19C326.65,113.41,331,115,332.38,116.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.41,115.05a7.88,7.88,0,0,0-4.29-2.36,24,24,0,0,1-4-.74c-1.44-.49-2.7-1.4-4.14-1.91a9.73,9.73,0,0,0-9.37,2.1c-1.12,1-2.15,2.21-3.6,2.51a16,16,0,0,1-2.19.1,7,7,0,0,0-5.48,3.79,12.08,12.08,0,0,0-1.32,5.22c-.07,1.62.69,3.09.76,4.66s-1.41,3.15-1.77,4.74,0,3.72,1.45,4.67a6.66,6.66,0,0,1,1.66-4.35,8.75,8.75,0,0,0,1.73,6.65,7.2,7.2,0,0,0,6.21,2.68,21.39,21.39,0,0,1,2.74-.35c1.81.07,3.31,1.35,4.73,2.48a7.14,7.14,0,0,0,5.75,1.83c2.3-.32,4.78-.65,6.78-1.88a26.91,26.91,0,0,0,5.48-4.25c3.39-3.6,4.34-8.27,3.89-13.06a14.21,14.21,0,0,0-1.2-4.93,8.4,8.4,0,0,0-1.33-2c-.11-.13-1.21-1.05-1.26-.71A6.53,6.53,0,0,0,329.41,115.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.38,132.38c-1.93-.69-3.53.06-4.51,2.1-.84,1.76-2.74,1.19-2.36-1.53-4.4-4,.54-6.72-3.11-10.59-2.27-2.42-7-1.64-8.82,0a4.63,4.63,0,0,0-5.4-2c-2,.74-3.2,2-4.09,4.73s.12,3.41-.31,5.44a23.25,23.25,0,0,0-.9,4.35c-.5,6.76,1.64,10.58,3.77,12.08a11.49,11.49,0,0,0,6.89,1.89l-.21,3.77s-4.48,6.3-4.34,11.08a57.77,57.77,0,0,0,11.82-4.78c6-3.31,6.45-5.71,6.45-5.71l.2-12.31h0c.47,1.07,3.18,2.29,5.35.43C333.55,138.91,333.79,133.58,330.38,132.38Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.86,128.59l3-1.24a1.58,1.58,0,0,0-2.09-.94A1.73,1.73,0,0,0,302.86,128.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,128.09l2.79,1.73a1.58,1.58,0,0,0-.47-2.24A1.72,1.72,0,0,0,313.88,128.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4,139.23l-4.54,1.57a2.41,2.41,0,0,0,3.27,1.4A2.26,2.26,0,0,0,313.4,139.23Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.81,142.36a2.52,2.52,0,0,1,2.49-2.29l.23,0a2.12,2.12,0,0,1-1.4,2.11A2.78,2.78,0,0,1,310.81,142.36Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.02 129.61 308.81 137.99 304.63 136.38 310.02 129.61",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.51,131.75a1.38,1.38,0,1,0,1.42-1.33A1.38,1.38,0,0,0,312.51,131.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.26,130.94a1.38,1.38,0,1,0,1.42-1.33A1.37,1.37,0,0,0,303.26,130.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,148.79c4.4-.72,9.24-1.17,12.09-7.26a11.12,11.12,0,0,1-4.81,6.93,17.62,17.62,0,0,1-7.28,2.45Z",
    style: {
      fill: "#9a4a4d"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--backpack--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.59,168.82l13.9-5.07,1.8-16.92s-8.68,2.14-10.58,5C146.64,156.48,144.24,163.18,144.59,168.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,168.82l13.9-5.07,1.8-16.92s-8.68,2.14-10.58,5C146.64,156.48,144.24,163.18,144.59,168.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.49,141.64c3.87.38,8.41,3.74,9.33,5.4,1.69,3.05,3,40.88-.72,44.49-4.7,4.53-26.16,12-35,10.69-7.32-1.08-11.48-6.49-12.38-8.58-1.46-3.43,6.75-36.75,9.5-40.19C155.67,147.89,175.56,141.15,180.49,141.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.49,141.64c3.87.38,8.41,3.74,9.33,5.4,1.69,3.05,3,40.88-.72,44.49-4.7,4.53-26.16,12-35,10.69-7.32-1.08-11.48-6.49-12.38-8.58-1.46-3.43,7.15-37.81,9.91-41.24C156.07,146.84,175.56,141.15,180.49,141.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,179.91a171.07,171.07,0,0,0,1.74-24.61c.36-2.41-1.9-7.36-1.9-7.36a19.76,19.76,0,0,0-6.44,4.46c-2.76,3.43-11.37,37.8-9.91,41.24h0l.17.35,0,0c.06.12.14.25.22.38l0,.06c.08.14.17.28.27.43l0,.05c.1.16.22.32.34.49h0q.39.53.9,1.11h0l.54.58h0a17.41,17.41,0,0,0,7.6,4.57C156.49,201.48,156.59,191.11,158.2,179.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,155.3c.36-2.41-1.9-7.36-1.9-7.36a19.76,19.76,0,0,0-6.44,4.46,3,3,0,0,0-.29.44,7.09,7.09,0,0,0,1.93,3.14,27.78,27.78,0,0,0,6.64,4.2C160,157.12,159.94,155.3,159.94,155.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,175.63c.17-.06,2.77-1.56,3.06-1.67.52-.19,7,5.44,7.57,6.33.38.62-2.19,15.2-2.54,15.79-.13.22-2.94,1.47-3.06,1.68-.36.59-7.24-5.17-7.56-6.41S145.22,175.91,146,175.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,175.63c.17-.06,2.77-1.56,3.06-1.67.52-.19,7,5.44,7.57,6.33.38.62-2.19,15.2-2.54,15.79-.13.22-2.94,1.47-3.06,1.68-.36.59-7.24-5.17-7.56-6.41S145.22,175.91,146,175.63Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,182c.39.62-2.18,15.21-2.53,15.8s-7.24-5.17-7.56-6.41,1.77-15.44,2.53-15.72C146.49,175.44,153,181.07,153.54,182Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,174c-.29.1-2.89,1.61-3.06,1.67.51-.19,7,5.45,7.56,6.33l3.07-1.67C156.05,179.4,149.56,173.77,149,174Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,182c.39.62-2.18,15.21-2.53,15.8s-7.24-5.17-7.56-6.41,1.77-15.44,2.53-15.72C146.49,175.44,153,181.07,153.54,182Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61,180.29c-.49-.4-2.16.24-2.91.75s-1.82,3.15-3.63,3.37-4-2.4-4.34-3.95-.57-4.75.41-5.76a2.9,2.9,0,0,1,3.7-.61C151,174.91,156.62,178.91,156.61,180.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61,180.29c-.49-.4-2.16.24-2.91.75s-1.82,3.15-3.63,3.37-4-2.4-4.34-3.95-.57-4.75.41-5.76a2.9,2.9,0,0,1,3.7-.61C151,174.91,156.62,178.91,156.61,180.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.56,180.54a1.34,1.34,0,0,1,.47,1.29.53.53,0,0,1-.86.36,1.28,1.28,0,0,1-.47-1.28C147.82,180.45,148.2,180.28,148.56,180.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.88,160.18s.62-1.41-5.1-5.82c-3.77-2.91-4.23-2.31-6.16,1.22-1.09,2-2.25,4.49-4,13.24-.77-.11-1.09-2.54.27-7.74,2.11-8.05,4.53-12.18,9-14.23,11.48-5.23,19.17-7,26.24-5.62C186.72,142.55,191,145,190.6,151,190.6,151,180.91,161.36,159.88,160.18Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.73,320.63l-1-12.88,15.53-1.26s-.89,10.13-.92,14.78a27.37,27.37,0,0,0,1.38,6.36s-6.19,3.09-9.32,1.68-5.09-6.61-5-7.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,343.68c.22,0,.26,2.07-1,3a15.11,15.11,0,0,1-11.11,2c-5.19-1.08-7.9-2.93-9.86-4.86s-4.71-4.66-7-5.37a16.82,16.82,0,0,1-5.66-3.42c-.65-.75-.33-3.8-.33-3.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,319.4s-.29.13-.47.83-.59,3.27-1,4.62a25.31,25.31,0,0,0-1.07,7.4c.17,1.59,4.21,3.79,6.44,4.85a29.39,29.39,0,0,1,7.07,5.3c2.3,2.24,7.32,4.77,10.73,5,4,.27,8.69-.71,9.87-2.53,1.46-2.25,2.61-4.9-3.17-8.16-1.09-.61-4.89-3.3-6.19-4.27-3.49-2.61-5.91-4.95-7.29-9.22a2.33,2.33,0,0,0-.77-1.33,1.88,1.88,0,0,0-1.15-.19,39.39,39.39,0,0,0-6,.69c-.83.33-2,.7-2.07,1.74a3.55,3.55,0,0,0,.15,1.07c0,.22.09.51-.1.62s-.41-.05-.55-.2a15.28,15.28,0,0,1-1.47-2.08,17.51,17.51,0,0,0-1.41-1.89,10.41,10.41,0,0,1-1-.75A2.38,2.38,0,0,1,188.64,319.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.57,342.4c-1-.95-2-1.87-3.08-2.71h0s6.71,4.87,9.7,3.11c1.93-1.13,1.17-2.73,1.17-3.23s6.72-3.48,8.52-3.56h0a11.91,11.91,0,0,0,1.12.71c4.54,2.24,5,4.73,4,7.74-1.19,1.82-5.39,3.47-10.61,3.08C207,347.27,201.87,344.64,199.57,342.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,338.09c3.61,1.79,2,2.37.92,2.45s-7-4.11-10.64-7.46-6.53-8-7.92-9.29c-.52-.48-1.07-1.06-1.57-1.6.16-.82.3-1.57.41-2,.18-.7.47-.83.47-.83a4.58,4.58,0,0,0,.57,1.5,10.41,10.41,0,0,0,1,.75,17.51,17.51,0,0,1,1.41,1.89,15.28,15.28,0,0,0,1.47,2.08C196,330,203.36,336.31,207,338.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,340a.32.32,0,0,1-.22-.1.37.37,0,0,1,0-.53c1.14-1.22,6.35-3.94,9.07-3.43a.38.38,0,0,1,.3.44.37.37,0,0,1-.43.3c-2.54-.47-7.5,2.24-8.41,3.21A.38.38,0,0,1,207.66,340Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57,337.69a.37.37,0,0,1-.23-.1.38.38,0,0,1,0-.53c1.15-1.22,6.36-3.93,9.07-3.42a.36.36,0,0,1,.3.43.37.37,0,0,1-.43.3c-2.54-.47-7.5,2.24-8.41,3.21A.34.34,0,0,1,204.57,337.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.46,335.53a.32.32,0,0,1-.22-.1.37.37,0,0,1,0-.53c1.14-1.22,6.35-3.94,9.07-3.42a.37.37,0,0,1-.13.73c-2.54-.47-7.5,2.24-8.41,3.21A.38.38,0,0,1,201.46,335.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.62,333.12a.43.43,0,0,1-.23-.1.38.38,0,0,1,0-.53c1.15-1.22,6.37-3.94,9.07-3.43a.37.37,0,0,1,.3.44.37.37,0,0,1-.43.3c-2.53-.47-7.5,2.23-8.41,3.2A.33.33,0,0,1,198.62,333.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.83,330.71a.4.4,0,0,1-.22-.1.38.38,0,0,1,0-.53c1.58-1.73,7-3.92,9.71-3.42a.38.38,0,0,1,.29.44.37.37,0,0,1-.43.3c-2.44-.46-7.62,1.65-9,3.19A.35.35,0,0,1,195.83,330.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.34,325.1l3.89-15.71-15.1-2.85-.66,15.6s-1.27,4.16-.45,5.63,9.88,3.23,10.74,2.29S164.34,325.1,164.34,325.1Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.16,350c-.49,3.53-1.27,5.81-2.82,7.69s-4.21,2.13-6.81,1.11-5.88-3.18-6.41-6.37a17.87,17.87,0,0,1,.63-8.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,322.14c-1.1-.09-.87,2.71-1.52,7.47-.7,5.16-3.07,9.15-4,13.27-1.05,4.71-.93,6.91.7,10.11s8,7.05,11.51,3.38c2.88-3,3.27-6.75,3.39-11.6a109.38,109.38,0,0,1,.67-12.28c.48-3.57,2-6.85,1.11-7.39-.11.52-1.14,4.12-1.76,4a6.86,6.86,0,0,1,.09-1.36,1.56,1.56,0,0,0-.21-1.21,5.13,5.13,0,0,0-1.74-1c-1.07-.36-3-.82-4.05-1.08-.54-.12-1.08-.23-1.63-.31a4.7,4.7,0,0,0-1.4,0,.89.89,0,0,0-.63.4,1.36,1.36,0,0,0-.09.54,3.59,3.59,0,0,1-.22,1c0,.13-.17.29-.32.23a.33.33,0,0,1-.16-.32C152.26,325.42,152.42,322.44,152.47,322.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.31,341.55c-.16.68-1.15,5.18.17,6.22s2.5-2.36,2.5-2.36,3.56-.44,8.48,2.36c-.32.71.28,3.29,1.71,3s2.36-5.49,2.38-5.56c-.14,4.64-.58,8.27-3.38,11.18-3.54,3.67-9.88-.19-11.51-3.38s-1.75-5.4-.7-10.11C147.06,342.41,147.18,342,147.31,341.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,345.77c-.15,1.74-2,.87-1.89-1.61s1.53-8.44,2.11-12.47c.47-5.8.8-9.64,1.9-9.55,0,.06,0,.12,0,.18s-.2,3.31-.23,3.68c-.29,3.55-.52,10.45-1.09,13.65A52.9,52.9,0,0,0,150.35,345.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,347.63a50.84,50.84,0,0,0,1.49-5.95c.62-3.16,2.64-9.47,3.64-12.86.31-.55,1.33-3.72,1.33-3.72.75.24-.09,3.27-.48,4.68s-.87,2.93-1.37,5c-1.25,4-1.52,10-2.31,12.34S157.39,349.29,157.88,347.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,347.93l-.15-.06a14.64,14.64,0,0,0-8.35-2.09.46.46,0,0,1-.48-.34.34.34,0,0,1,.32-.41,15.46,15.46,0,0,1,8.94,2.24.37.37,0,0,1,.13.52A.38.38,0,0,1,158.56,347.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,344.29a.31.31,0,0,1-.13-.06,18.36,18.36,0,0,0-9.36-2.33.44.44,0,0,1-.46-.35.33.33,0,0,1,.33-.4,18.9,18.9,0,0,1,9.89,2.47.38.38,0,0,1,.15.52A.37.37,0,0,1,159.75,344.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,338.35a.44.44,0,0,1-.32-.3.33.33,0,0,1,.29-.43c5-.76,9.68,2.25,9.87,2.38a.37.37,0,0,1,.14.53.42.42,0,0,1-.56.07s-4.58-3-9.24-2.24A.55.55,0,0,1,150.79,338.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,335a.44.44,0,0,1-.32-.3.32.32,0,0,1,.27-.43,14.34,14.34,0,0,1,10.08,2.38.36.36,0,0,1,.1.53.42.42,0,0,1-.57,0,13.58,13.58,0,0,0-9.38-2.21A.55.55,0,0,1,151.33,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,331.26a.49.49,0,0,1-.32-.29.34.34,0,0,1,.27-.44c5.18-.95,10,2.35,10.15,2.5a.37.37,0,0,1,.11.52.42.42,0,0,1-.57.05s-4.65-3.22-9.45-2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,203c-1.79,14-2.93,21.8-3,40.22,0,7,.48,15.06.27,22a41.88,41.88,0,0,1-.24,6.14c-.68,3.61-1.45,7.24-2.25,10.85a64,64,0,0,0-1.36,8c-.37,4.05-.06,8.19-1,12.16a38.59,38.59,0,0,0-1,4.47,6.84,6.84,0,0,0,.14,2.47c.2.81.83,1.36,1.07,2.09.34,1.07,0,2.66-.05,3.8,0,0,9,4.24,14.72,2.33.29-1,.4-2.68,1-3.5.42-.59,1.38-.91,1.89-1.48a5.54,5.54,0,0,0,1.17-2.14,21.32,21.32,0,0,0,.38-3.4c.29-2.68,1.56-5.13,2.47-7.67,2.45-6.84,2.2-14.16,3.77-21.18,2.12-9.47,3.17-15.47,4.4-22.23s3.59,13.59,3.59,13.6a23,23,0,0,1-.25,3.69c-.15,2.4-.14,4.77-.5,7.14a51.32,51.32,0,0,0,.1,15.89,28.44,28.44,0,0,1,.65,7.46c-.12,1.64-.43,3.09.17,4.63.43,1.1,1.08,1.38,1.63,2.41.23.42.17,3.72.42,3.88,0,0,9.25,5.14,15.27.33a14.48,14.48,0,0,1,.46-3.7,5.2,5.2,0,0,0,1.82-3.57c.14-1.54-.3-2.69-.28-4.24a49.6,49.6,0,0,1,.64-5.68,64.86,64.86,0,0,0,.47-8.13c0-2.36-.32-4.87.09-7.17a99.21,99.21,0,0,0,1-11.82c.78-15.34,1.59-46.58.35-66.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.16,221.72c-.48,16-6.83,20.1-9.8,21.22C157.36,242.94,164,236,167.16,221.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,228.72l-5.2,30.11c.17-.92.34-1.85.51-2.8,1.23-6.75,3.59,13.6,3.59,13.6l-.43-13.27A55.75,55.75,0,0,1,186.2,244l3-12.92a15.08,15.08,0,0,0,9.29-6.93C194.84,227.55,186.64,228.72,186.64,228.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,315.83c2.49,2.13,9.85,4.08,15,2.33l1.14-4.38c-3.86,1.23-11.73.17-15.9-2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.75,315.24c1.67,1.84,10.5,3.24,15.28.53l.46-4.41c-3.61,1.95-12.71,1.68-16.15-.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.63,246.37s-.06,20.15,0,21.59,10.37,4.56,10.67,3.66c.49-1.51.46-4.91,1.8-21.23C160.44,249,156.63,246.37,156.63,246.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,256a3.21,3.21,0,0,0-1-.11l-1.14-.09a16.36,16.36,0,0,1-2.4-.45,18.67,18.67,0,0,1-2.61-.89c-.69-.29-1.34-.68-2-1-.06,0-.08.1,0,.13a10.07,10.07,0,0,0,2.17,1.22,16.35,16.35,0,0,0,2.16.78,17.66,17.66,0,0,0,2.38.5c.41.06.81.1,1.21.12a2.51,2.51,0,0,0,1.28-.06A.11.11,0,0,0,167.28,256Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,253.09c-.1-.2-.17-.33-.4-.36a.69.69,0,0,0-.52.12.66.66,0,0,0-.28.44.76.76,0,0,0,.36.75.68.68,0,0,0,.74,0,.53.53,0,0,0,.2-.45A1.29,1.29,0,0,0,162.82,253.09Zm-.22.6a.42.42,0,0,1-.53.09c-.26-.17-.19-.7.14-.72a.38.38,0,0,1,.29.08A.46.46,0,0,1,162.6,253.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.45,187.44a10.37,10.37,0,0,0,5.35.51c2.46-.24,3.67-.54,5,.2s1.49,1.48,2.59,1.82a60.77,60.77,0,0,1,5.89,2.33,2.38,2.38,0,0,1,.33,3.42c1.17,0,1.66,2.11-.17,3.84,1,.27,1.1,2.31-.1,3.38.39.73.07,1.72-1.06,2.43a16.71,16.71,0,0,1-3.42,1.51c-.81.27-1.52,0-2.69-.62a11.51,11.51,0,0,1-2.22-1.44c-.91.08-3.11.46-7.1-2.58a19.18,19.18,0,0,0-6.21-3.45S228.56,189,233.45,187.44Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,196.29A11.47,11.47,0,0,0,240,196a5,5,0,0,0,.9-.36,1.64,1.64,0,0,0,.58-.56l.11-.21a6.69,6.69,0,0,1,.51-.9,1.77,1.77,0,0,1,.94-.76,1.72,1.72,0,0,0-1,1.3,9.82,9.82,0,0,0-.46,1.85,4.9,4.9,0,0,0,.1,1.87,1.85,1.85,0,0,0,.78,1.21l.07,0a1.46,1.46,0,0,0,1.87-.78c.81-1.43,1.68-2.81,2.39-4.27,1.07-1.88.28-2.8-.88-4.31,1.23,1.38,2,2.36,1.21,4.13l.17-.13a2.09,2.09,0,0,1,.6-.24,1.2,1.2,0,0,1,.5,0s0,.08,0,.08-.33.07-.49.14a2.16,2.16,0,0,0-.51.29,2.24,2.24,0,0,0-.36.33l-.14.18a.68.68,0,0,1-.12.12c-.58,1.18-1.25,2.32-1.89,3.46,1.39,0,2.92.52,4.23,0a4.47,4.47,0,0,0,.9-.61c.86-.66,1.83-1.37,2.67-2.05a20.58,20.58,0,0,1-3.46,2.92c-1.45.52-2.91,0-4.35-.25l-.21.38a2,2,0,0,1-.93.89,1.52,1.52,0,0,1-.5.12c1.45.54,2.94,1.71,4.49,1.49,1.57-.52,3.18-1.22,4.79-1.71-1.57.7-3.1,1.43-4.74,2-1.57.2-2.92-.83-4.25-1.57a2.45,2.45,0,0,0-1.65.61c-.79,1.13,2.77,3,3.62,3.47a3.67,3.67,0,0,0,3.45.13,34.89,34.89,0,0,0,3.47-1.24,23.58,23.58,0,0,1-3.4,1.44,5.91,5.91,0,0,1-1.83.44,4,4,0,0,1-1.81-.53,16.48,16.48,0,0,1-2.72-1.77c-.76.59-.11,1.67.37,2.3-.81-.49-1.35-1.94-.41-2.33-.78-.67-1.29-1.4-.84-2a2.42,2.42,0,0,1,1.74-.53l-.33-.18a1.59,1.59,0,0,1-1.58-1.11,5.26,5.26,0,0,1-.2-3.06A7.3,7.3,0,0,1,238,196.29Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.12,168.73l3.65-22.5c4.86,1.15,7.53,3.39,11.47,15.21,3.38,10.14,5.06,15.58,5.06,15.58s11.9,8.8,16.08,10.89l-3.74,11.16c-3.81-1.42-6-2.12-13.32-5-8.2-3.18-9.52-3.52-11.82-8.3-1.66-3.45-1.54-3.26-3.53-7.81C198.57,170.2,198.12,168.73,198.12,168.73Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,145.64c6.07,1.36,8.37,4,11.42,12.48s5.22,16.54,5.22,16.54a17.35,17.35,0,0,1-7,6.64c-4.56,2.17-7.86,1.35-7.86,1.35L197.38,169Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-38",
    d: "M177.3,143.75s-11.29,2.46-13.85,3.32c0,0-6.81,4.55-5.16,25.83.23,3,.77,11.6.58,18.82-.13,5.14-1.18,20.43-1.48,24,0,0,13.85,4.22,33.74,2.43,15.61-1.4,17.39-8.26,17.39-8.26s.41-29.51-.12-41.4c-.7-15.62-2.86-17.89-7.14-22.85-.55-.35-11.1-2.16-11.1-2.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,159.59a56.1,56.1,0,0,1,.86,10.25c-7.77,2.61-17.22,4.53-26.31,4,0-3.84-.22-7-.52-10.67A82.9,82.9,0,0,0,203,159.59Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.71,112a5.78,5.78,0,0,0-4,3.47c-.75,1.57-1.22,5.41,1.48,13.17a30.94,30.94,0,0,0,4.48,8.48,4.1,4.1,0,0,0,2.49,1.66l-.5-6.07-.44-5.25s3.55-1.18,4.21-6c.54-3.92-1.13-5.41-1.13-5.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,115c-1-6,10.55-14.58,17.69-10.26,2.41-3.34,8.23-1.9,8.81,1.52,2.07-1,6.08,3.8,5.14,6.35,2,5.63-.87,7.9-3.65,7.85-6.79-.12-14.06-.5-20.91-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.28,112.21c1.42,1.29,3.46,4.2,3.92,15,.32,7.34-1.51,10.59-4.19,11.89a16.07,16.07,0,0,1-7.19,1.52l0,4.4c6.41,6-11.1,7.51-15.41-.37l.13-12c-.47.89-2.83,1.48-4.58-.24-2.78-2.72-2.25-6.66-.21-8.14A3.89,3.89,0,0,1,178,126c2.35.8,4.07-2.43,3.33-11.27C190.82,117,193.23,109.48,199.28,112.21Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.82,140.62c-7.69-.37-11.26-4-12.18-6.81,0,0-.32,4.84,5,7.23a15.05,15.05,0,0,0,7.1,1.44Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.13,131.22l-5.06-1.5a2.51,2.51,0,0,0,1.67,3.25A2.77,2.77,0,0,0,195.13,131.22Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.88,133.05a2.61,2.61,0,0,1-1.14-.08,2.48,2.48,0,0,1-1.77-2A3,3,0,0,1,192.88,133.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.29,122.88a1.42,1.42,0,0,0,1.56,1.28,1.43,1.43,0,1,0-1.56-1.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,122.06a1.44,1.44,0,0,0,2.86-.27,1.41,1.41,0,0,0-1.56-1.28A1.43,1.43,0,0,0,197.5,122.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.45 119.34 194.73 128.17 198.81 126.15 192.45 119.34",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09,119.33l-3.38-.82a1.67,1.67,0,0,1,2-1.3A1.81,1.81,0,0,1,201.09,119.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.38,120.68l3.1-1.7a1.7,1.7,0,0,0-2.35-.73A1.84,1.84,0,0,0,185.38,120.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cap--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.64,111.93c-14.06.07-20,6.51-20,6.51-1.61,1.11-4.2,3.17-5.07,5.07A4.46,4.46,0,0,0,171,125a10.45,10.45,0,0,1-1-2.9c-1-4.72-1.16-14.48,10-18.23,10.24-3.45,17.49-1.82,19.74,3.65A23.4,23.4,0,0,1,200.64,111.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.31,117.12a19.25,19.25,0,0,1,6.42-7.83c3.13-2.36,10.05-3.49,13.17-3.9,5.46-.72,6.93.29,7.11,1.1,0,.2.24,1.1.3,1.3a.84.84,0,0,1,0,.55c-.64,1.4-4.74,4.26-4.74,4.26-7.08-.93-15.43,1.46-21.91,5.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.62,118.44a35.38,35.38,0,0,1,21.91-5.84s4.1-2.86,4.74-4.26c.34-.77-.3-2.52-7.06-1.63-3.12.41-10.05,1.54-13.17,3.91A19.19,19.19,0,0,0,180.62,118.44Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "179.8 233.56 179.75 208.43 146.38 188.71 146.43 213.85 179.8 233.56",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.8 233.56 179.75 208.43 146.38 188.71 146.43 213.85 179.8 233.56",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,208.67V233c-1.56.28-2.12.65-3.55,2.14l0-24.15S175.23,210.55,178.85,208.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,212.68a4.27,4.27,0,0,1,1.94-3.33l2.45-1.39c1.07-.6,1.92-.09,1.92,1.14v24l-.84.48-.05-23.66c0-.73-.51-1-1.15-.67l-2.19,1.26a2.57,2.57,0,0,0-1.17,2l0,23.64-.95.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,212.68a4.27,4.27,0,0,1,1.94-3.33l2.45-1.39c1.07-.6,1.92-.09,1.92,1.14v24l-.84.48-.05-23.66c0-.73-.51-1-1.15-.67l-2.19,1.26a2.57,2.57,0,0,0-1.17,2l0,23.64-.95.54Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,236.67,141,217V193a4.2,4.2,0,0,1,1.94-3.32l2.44-1.39a1.34,1.34,0,0,1,1.36-.12l33.37,19.71a1.36,1.36,0,0,0-1.36.12l-2.45,1.39a4.27,4.27,0,0,0-1.94,3.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.91,210.78a4,4,0,0,1,1.37-1.43l2.45-1.39a1.36,1.36,0,0,1,1.36-.12l-33.37-19.71a1.34,1.34,0,0,0-1.36.12l-2.44,1.39a3.85,3.85,0,0,0-1.37,1.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.91,210.78a4,4,0,0,1,1.37-1.43l2.45-1.39a1.36,1.36,0,0,1,1.36-.12l-33.37-19.71a1.34,1.34,0,0,0-1.36.12l-2.44,1.39a3.85,3.85,0,0,0-1.37,1.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,193.74c2.06-1.88,3.18-2.51,5.22-3l1.59.94c-2,.45-3.16,1.07-5.21,3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,206.66c2.05-1.89,3.13-2.49,5.17-2.94l1.59.94c-2,.44-3.12,1.05-5.18,2.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146,193.74c2.06-1.88,3.18-2.51,5.22-3l1.59.94c-2,.45-3.16,1.07-5.21,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,206.66c2.05-1.89,3.13-2.49,5.17-2.94l1.59.94c-2,.44-3.12,1.05-5.18,2.94Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.38,147.78c-6.43,1.75-8.44,2.5-13.6,14.32-4.87,11.13-7.29,16.31-9.41,22-1.83,4.91-1.44,6.31,1,15.77,1.29,4.93,6.77,20.85,7.63,26.06a20,20,0,0,0,4.21,8.85c.62.81,1.52,2.24,2.48,2.64,1.54.63,3.39-.43,5-.37a8.09,8.09,0,0,0,2.81.1c.8-.27,1.38-1,2.2-1.2.54-.13,1.12,0,1.65-.13a2.14,2.14,0,0,0,1.34-2.13,1.14,1.14,0,0,0-.05-.39l-1.93-1.13c-1.05-1.19-3.12-3.69-3.42-5.18-.4-2,2.21-1.72,4.69-1.6a4.25,4.25,0,0,0,4.24-3.24c.1-1.16-4.23-.2-6.78-1.11s-6.14-1.92-7.58-3.69c-2.2-2.7-3.12-26.93-3.12-26.93l10.35-21.21S170.55,156.68,163.38,147.78Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.45,147.07c-5.72,1.24-8.07,2.24-11,8.28s-9.75,21.25-9.75,21.25.12,2.62,6.21,6.15c5.73,3.34,9,2.63,9,2.63s4.81-9.93,7.78-16.53S170.6,153.57,163.45,147.07Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.73,145.7c6.7,6.26,5.35,40.44-10.29,47.47v-3.4s5.27-5.33,7.47-21.84A38.69,38.69,0,0,0,163,147.16,30.21,30.21,0,0,1,168.73,145.7Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--backpack--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.08,230.17c-.82,1.42-3.19.05-7.31-1.43S428.82,209,428.82,209s6.53-.12,7.85,5.94S439.08,230.17,439.08,230.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,230.17c-.82,1.42-3.19.05-7.31-1.43S428.82,209,428.82,209s6.53-.12,7.85,5.94S439.08,230.17,439.08,230.17Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.36,199.12c-3.85,0-12.24,4.68-13.52,7.71s-5.39,45.84-2,49.74c4.23,4.89,24.72,14.17,33.59,13.67,7.31-.41,14.11-7.3,15.18-9.28,1.75-3.26-1.62-47-4-50.62C429.66,204.46,409.27,199.08,404.36,199.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.36,199.12c-3.85,0-12.24,4.68-13.52,7.71s-5.39,45.84-2,49.74c4.23,4.89,24.72,14.17,33.59,13.67,7.31-.41,14.11-7.3,15.18-9.28,1.75-3.26-1.62-47-4-50.62C429.66,204.46,409.27,199.08,404.36,199.12Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.36,199.12c-3.85,0-12.24,4.68-13.52,7.71s-5.39,45.84-2,49.74c4.23,4.89,24.72,14.17,33.59,13.67,7.31-.41,14.11-7.3,15.18-9.28,1.75-3.26-1.62-47-4-50.62C429.66,204.46,409.27,199.08,404.36,199.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.87,232.48c-.16-1.83-.33-3.64-.51-5.38q-.11-1-.21-2.07c-.15-1.35-.3-2.66-.46-3.9-.07-.62-.15-1.22-.23-1.8-.12-.88-.24-1.71-.35-2.48s-.24-1.51-.36-2.17c0-.23-.08-.44-.12-.65a13.07,13.07,0,0,0-1.06-3.69c-.11-.16-.24-.33-.38-.5l-.14-.16-.3-.34a1.8,1.8,0,0,1-.19-.2l-.34-.31-.21-.2-.54-.45-.37-.29-.25-.19-.44-.31-.22-.16-.5-.34c-3.42,1.53-6.66,3-6.75,3s-3.67,2.34-3.37,7.71l.56,21.75,0,2.07c.12,2.88-1.71,29.56,6.4,27.83l.33-.07c5.43-2.07,9.85-6.69,10.7-8.26a5,5,0,0,0,.32-1.47c0-.28.05-.6.08-.95l0-.54c0-.57,0-1.21.05-1.9v-.71c0-3.66-.2-8.71-.54-14.11-.07-1.08-.15-2.18-.23-3.28-.05-.73-.11-1.47-.17-2.21,0-.37-.05-.73-.08-1.1C437,234,436.93,233.22,436.87,232.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.36,212.74a8.91,8.91,0,0,0-.79-2.4c-3.91-5.88-24.3-11.26-29.21-11.22-3.85,0-12.24,4.68-13.52,7.71a22.39,22.39,0,0,0-.77,3.93c7.79,3.89,27.88,12.46,29.9,11.67,2.49-1,14.17-9.32,14.38-9.68Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.69,241.08c-.23-.11-3.68-2.54-4.07-2.73-.7-.33-10.5,6.72-11.39,7.9-.62.82.74,13.14,1.16,14,.15.31,3.93,2.41,4.07,2.72.42.87,10.78-6.31,11.38-8S439.72,241.56,438.69,241.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.69,241.08c-.23-.11-3.68-2.54-4.07-2.73-.7-.33-10.5,6.72-11.39,7.9-.62.82.74,13.14,1.16,14,.15.31,3.93,2.41,4.07,2.72.42.87,10.78-6.31,11.38-8S439.72,241.56,438.69,241.08Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,249c-.62.81.75,13.13,1.16,14s10.78-6.31,11.38-8-.12-13.43-1.15-13.91C438,240.75,428.19,247.8,427.3,249Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.62,238.35c.39.18,3.83,2.62,4.07,2.72-.7-.32-10.5,6.73-11.39,7.9l-4.07-2.72C424.12,245.07,433.92,238,434.62,238.35Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,249c-.62.81.75,13.13,1.16,14s10.78-6.31,11.38-8-.12-13.43-1.15-13.91C438,240.75,428.19,247.8,427.3,249Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23,246.25c.73-.51,3,.61,4,1.41s2.14,4.64,4.64,5.17,5.9-2.85,6.57-5,1.41-6.56.16-8.1-3.38-2.33-5.1-1.33S423.38,244.31,423.23,246.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23,246.25c.73-.51,3,.61,4,1.41s2.14,4.64,4.64,5.17,5.9-2.85,6.57-5,1.41-6.56.16-8.1-3.38-2.33-5.1-1.33S423.38,244.31,423.23,246.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.45,247.62a1.84,1.84,0,0,0-.81,1.74.74.74,0,0,0,1.15.62,1.8,1.8,0,0,0,.81-1.74C435.51,247.58,435,247.3,434.45,247.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.7,222.48s1.21-5.15,7.28-8.92,6.3-2.65,8.38.75c1.88,3.05,2.95,14.64,3.07,15.75s1.44.86,1-6.24S437.82,210,431.06,206c-9.09-5.39-23-8.65-29.47-7s-12.2,5.07-11.52,11.84C390.07,210.76,398.85,221.76,419.7,222.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.7,222.48s1.21-5.15,7.28-8.92,6.3-2.65,8.38.75c1.88,3.05,2.95,14.64,3.07,15.75s1.44.86,1-6.24S437.82,210,431.06,206c-9.09-5.39-23-8.65-29.47-7s-12.2,5.07-11.52,11.84C390.07,210.76,398.85,221.76,419.7,222.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.82,256.94l27.47,2.46L400.66,304a60.28,60.28,0,0,1,11.39,12.72c3.13,5,13.6,23.59,15.38,26.79a41,41,0,0,0,3.19,4.71c.65.85,1.54,1.24,1.82,2.26,1.25,4.51-1.51,12-4.22,15.84a10.31,10.31,0,0,1-2.68,2.75,6,6,0,0,1-3.7,1,2.43,2.43,0,0,1-2-1.05,3,3,0,0,1-.19-1.68,53,53,0,0,0,.49-6.28c-.12-4.45-3-8.66-6.07-11.88-4-4.26-30-34-31.49-36.05-2.27-3.1-4.74-5.67-5.74-16.36C375.84,285.93,375.09,262.5,375.82,256.94Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,257.29s-2.7,20.27-3.5,38.5c-.46,10.65.78,13.69,3.66,17.6,3.59,4.87,9.5,9.64,15.46,15.08,7.09,6.46,22.73,20.08,25.29,22.68,0,0,8.32-2.6,11.72-9.2,0,0-5.63-11.51-10.86-20.6S406,305.27,406,305.27L413.58,263Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.85,345.82l.74-.3c-3.88-9.06-18.81-34.43-24.63-39l-.52.61C405.07,311.54,420.09,337.05,423.85,345.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,336.62c-1.17,3-9,10.94-12.95,10.54l4.77,5.13c3.59-.09,9.52-5.65,11.27-9.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,263h0L406,305.27s2.21,3.05,5,7.4l.35.55c.1.16.2.32.31.48.77,1.21,1.59,2.52,2.43,3.91,0,0-1.14,6.63-1.19,6.92-.19,1,2.61,4.77,1.83,16.82-.15,2.33-.76,5.71-1.11,7.89a5.28,5.28,0,0,0-1.31-1c-5.6-5.07-16.55-14.65-22.15-19.76-.86-.79-1.72-1.56-2.57-2.32a148.21,148.21,0,0,1-.83-15.83c.22-4.76,2.11-28.48,2.11-28.48a19.92,19.92,0,0,1-5.78-4.41,12.63,12.63,0,0,1-2.92-5.13,76.41,76.41,0,0,1-3.48-9.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.61,353.25c.62-.2,1.42,1.95,1.57,2.66s-.76,3.76-1.45,5.38-2,3.74-2.4,6.22.18,6.62-1.45,10-6.21,7.26-12.76,7.86a8.82,8.82,0,0,1-5.09-1.1,2.92,2.92,0,0,1-1.1-2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.81,369a16.4,16.4,0,0,1,1.92-6.49c1.16-2.57,3-5.95,2.59-8.76a9.44,9.44,0,0,0-3.93-4.13c-2.1-1.31-2.61-3.15-3.73-2.7l.53.7a31.74,31.74,0,0,1-2.3,4.17,2.34,2.34,0,0,0-.28,2,6.42,6.42,0,0,1,0,3.48,11.26,11.26,0,0,0-.84-2.06,2.21,2.21,0,0,0-1.59-1.22c-1.32-.36-3.1.56-4,1.06-1.39.75-3.07,1.43-3.63,2.59-.48,1,.55,2.31,1,3.12,1.33,2.25.64,5.07,0,7.44-.65,2.54-1.76,6.14-3.32,8.29s-2.8,3.26-1.33,5.55a4.5,4.5,0,0,0,2.15,1.57,7.06,7.06,0,0,0,2.63.44,15.35,15.35,0,0,0,10.08-3.74,12.14,12.14,0,0,0,2.9-4.34C432.51,374.15,432.61,372,432.81,369Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.62,374.08a14.13,14.13,0,0,1-1.36,2.45c-1.57,2.18-2.8,3.26-1.33,5.55a4.5,4.5,0,0,0,2.15,1.57,7.06,7.06,0,0,0,2.63.44,15.35,15.35,0,0,0,10.08-3.74,10.8,10.8,0,0,0,2.49-3.47C431.19,374.13,422.57,371.8,416.62,374.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.63,378.31c-.22-4.57-.62-8.17-.93-12.33q-.63-8.4-1.3-16.81-.67-8.62-1.37-17.24c-.37-4.58.37-8.71,0-13.29a301.62,301.62,0,0,1,3-39.18,27.41,27.41,0,0,1-9.33-6.3c-6.95-6.89-7.92-13.5-7.92-13.5l3.22-.75,35.47-4.42c.83,5.64,2.37,13.5,2.79,20.92.87,15.22-9.73,44.14-9.73,44.14.49,2,3.49,10.54,2.59,18.54-1.42,12.62-1.71,26.05-2,32.87s-.91,10.65-.57,11.94c.25,1,.95,2.46.59,3.21-.49,1-1.33,1.5-2.47,2.93a53,53,0,0,1-4.21,4.69,14.59,14.59,0,0,1-4.66,3,12.09,12.09,0,0,1-6.84,1.15c-.79-.17-2.57-.55-2.74-1.32a2.42,2.42,0,0,1,.52-1.7c2.06-3.39,2.33-3.71,4.31-7.14C395.55,383.26,394.78,381.4,394.63,378.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.63,252.68c.72,6.42,1.65,10.79,1.91,15.48a81.33,81.33,0,0,1-1.27,18.45c-1.14,6.76-8,35-8.49,37.4,1.23,5,2.47,9.42,1.52,20.62-1.38,16.16-3.44,30.49-3.44,30.49s-9.42,2.37-14.9-.24c0,0-5.13-44.86-5.56-55.33-.38-9.1,3-39.31,3-39.31s-14.46-4.64-16.83-20.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.39,321.11c.31-1.85,1.26-6.44,2.46-12.25,2-9.76,4.76-23.13,5.58-29.05,1-7.06-.37-21.51-.38-21.66l.8-.07c0,.14,1.36,14.68.38,21.82-.82,6-3.47,18.79-5.59,29.1-1.15,5.58-2.15,10.39-2.45,12.23a18.27,18.27,0,0,0,.46,6.48,63.53,63.53,0,0,1,1.05,16.5c-.43,7.81-2.17,23.28-3.15,31.74l-.83.15c1-8.4,2.74-24.06,3.17-31.92a62.33,62.33,0,0,0-1-16.33A19.24,19.24,0,0,1,406.39,321.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.77,368.3c-2.93,1.78-13.64,2.56-16.57-.17l.7,6.92c3,2.11,11.17,2.29,15.11.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.89,391.47a3.39,3.39,0,0,1,0,2.41c-.32.73-1.38,1.56-3,2.61s-4,1.71-5.52,4.05c-1.06,1.65-3.1,5.29-6.7,7.38a16.7,16.7,0,0,1-13,1.82c-4.56-1.42-5-3.33-5-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.92,385.39a4.84,4.84,0,0,1-.93,2.21c-1.32,2.28-3.59,4.4-5.48,6.29a61.61,61.61,0,0,1-6.41,5.48c-1.86,1.39-3.07,2.86-3,4.09.33,3.85,5.11,5.56,10,5.42a15.79,15.79,0,0,0,8.18-2.53,16.11,16.11,0,0,0,3.7-3.67c2.15-2.93,2.54-4.45,5.14-6,2.21-1.33,4.69-1.65,6.81-4.84.8-2.15-.24-4.42-.58-6.58a22.17,22.17,0,0,1-.05-2.94,1.18,1.18,0,0,0-.93-1.2c0,.2-.06,1-.06,1a3.81,3.81,0,0,1-1.6,1.41c-1.17.59-2.25.08-3,1.07A7,7,0,0,0,403,386a7.21,7.21,0,0,1-1.22,2,11.49,11.49,0,0,0,.32-2c0-1.09,0-1.82-.54-2.2a13.62,13.62,0,0,0-2.76-1.11,17.76,17.76,0,0,0-4.17-.85,2.2,2.2,0,0,0-2.41.77,6,6,0,0,0-.29,2.7A.28.28,0,0,1,391.92,385.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.38,397.52c-.89.73-1.78,1.44-2.64,2.09-1.85,1.39-3.07,2.86-3,4.1.33,3.84,5.11,5.55,10,5.41a15.74,15.74,0,0,0,8.18-2.53,9.35,9.35,0,0,0,1-.73C395.13,403.08,389.45,397.12,381.38,397.52Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350,208.91a26,26,0,0,1-.17-4.49c.33-4.38-.84-7-2.69-10.91-.31-.67-.64-1.33-1-2a7,7,0,0,1-.44-1c-.11-.32-.22-.58-.64-.56a1.21,1.21,0,0,0-.78.4,3.59,3.59,0,0,0-.88,2.77,18.37,18.37,0,0,0,.61,2.93c.17.74-.63.4-1,.18-1.74-1.07-3.2-4-4.12-5.75a25.81,25.81,0,0,0-1.76-3.53,4,4,0,0,0-1.88-1.51c-.53-.18-1.07-.17-1.23.51a2.91,2.91,0,0,0,.13,1.27,3,3,0,0,1-.12,2.45,6.75,6.75,0,0,0-.9,1.53,20.91,20.91,0,0,0-.14,2.25,17.51,17.51,0,0,1-.77,1.77,5.67,5.67,0,0,0,.23,2.3,17.88,17.88,0,0,0,1.57,4.49,18.37,18.37,0,0,0,3.86,5.4c.92,1,2.17,1.88,2.5,3.19a18.25,18.25,0,0,1,.47,3.76c.08,1.69.23,4.41.25,6.88.09,11.47,1.45,17.83,5.25,22.67,1.93,2.45,4.31,2.4,10.83-2,7.88-5.33,21.77-14.89,21.77-14.89l3.34-21s-8.06,1.06-12.31,4.19c-5.72,4.21-15.89,13.23-15.89,13.23S350.23,210.14,350,208.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.9,199.1a13.18,13.18,0,0,0,.54,7.3,7.71,7.71,0,0,1-1.5-3.67C342.81,200.65,343.27,199.81,343.9,199.1Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,205.51c-6.39,1.45-10.24,2-15.89,6.72-6.2,5.24-12.72,11.24-12.72,11.24A21.48,21.48,0,0,1,345.41,243c1,1.44,3,4.83,8.56,1.6s25.74-17.48,25.74-17.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.15,223.47c1.24,3.23,2.08,8,1.18,11.49,2.76-5.9.32-12.86.32-12.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.08,208.36s.56,10,1.3,19.8a127.82,127.82,0,0,1,.46,18.63c-.37,7.09.17,21.07.17,21.07-7.66,5.71-40.22,4-47.07-5.72.5-6.17.9-12.59.8-18.19-.13-6.86-1.59-18.54-.17-24.77,1.57-6.87,6.16-12.34,8.19-13.67,6.37-1.22,14.27-2,18.8-1.48A68,68,0,0,1,419.08,208.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.33,204.88h0a31.17,31.17,0,0,1,3.12.14,68.49,68.49,0,0,1,16.66,4c.14,2.34.65,10.86,1.27,19.2l0,.29a123.43,123.43,0,0,1,.44,18.2c-.33,6.26.05,17.94.15,20.61-2.78,1.76-8.58,2.79-15.71,2.79-11.48,0-25.1-2.84-29.32-8.28.43-5.24.89-11.93.78-17.92,0-2-.19-4.41-.35-7-.38-6.23-.82-13.28.16-17.57,1.45-6.38,5.63-11.53,7.6-12.94a87.64,87.64,0,0,1,15.18-1.58m0-1a89.71,89.71,0,0,0-15.57,1.63c-2,1.33-6.62,6.8-8.19,13.67-1.42,6.23,0,17.91.17,24.77.1,5.6-.3,12-.8,18.19,4.25,6.05,18.39,9,30.34,9,7.32,0,13.82-1.1,16.73-3.27,0,0-.54-14-.17-21.07a127.82,127.82,0,0,0-.46-18.63c-.74-9.83-1.3-19.8-1.3-19.8A68,68,0,0,0,401.56,204a31.32,31.32,0,0,0-3.23-.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.74,198.15c3-3.73,5-5.94,7.11-11.32.84-2.18,2.26-7.55,1.61-10.44a5.17,5.17,0,0,0-3.69-4,6,6,0,0,0-1.81-5.79,4.52,4.52,0,0,0-4.65-1.17,3.87,3.87,0,0,0-6.54-2.41,4.09,4.09,0,0,0-4-2.27,4.46,4.46,0,0,0-3.91,2.84,7,7,0,0,0-4.28-1.93,4.14,4.14,0,0,0-3.93,2.2c-.64,1.42-.23,3.06.2,4.55a2.41,2.41,0,0,0-2.59-.22,2.38,2.38,0,0,0-1.19,2.31,6.94,6.94,0,0,1,.28,1.78,1.38,1.38,0,0,1-2.43.66,2.91,2.91,0,0,0,3.28,3.64,2.25,2.25,0,0,0,.79,2.26,2.65,2.65,0,0,0,1.86.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.42,193.67c.67,4,2.18,5.89,4.83,6.94a13.28,13.28,0,0,0,4.44.63l.26,3.27c-8.22,9.06,11.45,8.8,15.47.77l-.34-11.54s1.61,2.07,4.56.4a6.23,6.23,0,0,0,2.41-7.47c-1.23-3.06-4.12-2-5.05-1.16s-2,2.3-2.75,2.2c-1.16-.16-1.39-1.15-1.63-1.9a15.67,15.67,0,0,1-.56-5.81c-.76-.45-1.82-.89-2.1-1.84-1-3.43.17-4.4.91-5.84-2.95-2.19-7.64,1.31-11.06,1.58-3.93.31-4.71-2-6.84-1.8a19,19,0,0,0-2.21,6.76A45.86,45.86,0,0,0,378.42,193.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.69,201.24h0c3.12,0,7.65-.43,10.36-2.85a11.73,11.73,0,0,0,3.4-5.81s-.5,4.31-1.91,6.21a12.35,12.35,0,0,1-6.57,3.93,45.09,45.09,0,0,1-5.13.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.45,179l3.11-.75a1.53,1.53,0,0,0-1.87-1.2A1.68,1.68,0,0,0,380.45,179Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,180.86l-2.8-1.59a1.54,1.54,0,0,1,2.15-.65A1.68,1.68,0,0,1,394,180.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.53,187.56l4.34,1.59,1.14-8.4C386.46,180.44,384,184.63,382.53,187.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.27,190.61l-4.48,1.55a2.39,2.39,0,0,0,3.23,1.38A2.24,2.24,0,0,0,390.27,190.61Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.72,193.7a2.48,2.48,0,0,1,2.45-2.26.86.86,0,0,1,.23,0,2.09,2.09,0,0,1-1.38,2.08A2.69,2.69,0,0,1,387.72,193.7Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.17,205.29a33.92,33.92,0,0,0-7.88,19.81c-2.08,31.31,20.06,37.43,20.06,37.43s.4-6.45.75-11.71c0,0-15.78-8.42-14.75-24.42.73-11.4,6-18.34,8.84-19.16A45.09,45.09,0,0,0,409.17,205.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.23,262.47c-3-1-5-2.15-8.15-4.85-5.79-5-6.12-5.76-10.93-10.18-1.64-1.5-3.1-3-3.79-3.67a18.66,18.66,0,0,1-3.65-3.78,11.73,11.73,0,0,1-2-4.39c-.2-1.68-.78-3.4-.44-5.12.1-.5.27-1,.35-1.48a11.32,11.32,0,0,0,0-2.1,9.82,9.82,0,0,1,.51-3.61,6.27,6.27,0,0,1,1.69-2.55A2.22,2.22,0,0,1,402,220c-.2.9-.34,1.67-.5,2.73a7.53,7.53,0,0,0,1.83,4c1.79,2.45,3.35,3.72,3.58,3.24s-.43-2-.15-4.46,1-3.33,1.72-3.5c1.21-.28,1.17,1,1.64,3,.56,2.35,1.55,3.64,1.61,7.1.06,3-.45,3.72,1.22,5.1.95.79,4.21,2.68,4.21,2.68s-.86-3.31-2.29-8.95c-2.76-10.95-1.79-19.8,1.26-23.73,4.5,1.7,10.5,4.6,13.08,13.53,2.75,9.5,2.8,10.93,5.43,29.75C436.58,264.22,430.81,263.92,426.23,262.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,207.24c5.9,1.41,9.23,3.61,11.17,7.36,3,5.73,4.18,10.77,5.17,18.48,1.25,9.74,4.38,23.61,1.67,27.88-2.11,3.31-6.31,2.82-9.29,1,3.36-9.6.66-17.17-7.69-22.08,0,0-2.87-8.72-4.07-13.24S411.62,210.61,416.16,207.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19,239.92c3.82,2.93,12.19,7.22,13.21,11.82,0,0-.09-3.64-5.11-8.09a69,69,0,0,0-8.89-6.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.75,183.5a1.34,1.34,0,1,1-1.34-1.35A1.34,1.34,0,0,1,392.75,183.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,182.46a1.35,1.35,0,1,1-1.34-1.35A1.34,1.34,0,0,1,383.11,182.46Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.13,371.52c.07-4.2,1.22-36.59,1.22-36.59l-17.59,9.56c1.87,18.76,3.7,27.64,3.85,30.89h0a3.64,3.64,0,0,1,.09.66c-.11,3.69,4.38,5.85,7.85,8.43a66.67,66.67,0,0,0,9.42,6.08c2.54,1.28,8.35.66,9.05-.84-4.23-3.17-8.52-6-11.51-9.87C117.94,377.81,117.07,375.4,117.13,371.52Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,394.85a3,3,0,0,1-.76,3.17c-1.42,1.05-5.57,2.71-10.94,1.88s-8.24-2.46-10.34-4.18-5.05-4.17-7.47-4.75a15.29,15.29,0,0,1-5.38-2.23c-.71-.66-.51-3.51-.51-3.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.51,374.38s-.38-.05-.54.6-.45,3.06-.85,4.33a21.26,21.26,0,0,0-.76,6.91c.25,1.47,3.91,2.61,6.24,3.52a30.69,30.69,0,0,1,7.5,4.68,23.56,23.56,0,0,0,11.25,4.28c5.36.26,8.88-.95,10-2.68,1.4-2.14,1-4.35-5.1-7.18a63,63,0,0,1-6.54-4c-3.61-2.75-4.54-3.95-6.45-7.6a8.43,8.43,0,0,0-.84-1.62,1.91,1.91,0,0,0-2-.57,41.31,41.31,0,0,0-5.28,1c-.84.33-2,.71-2.05,1.68a3.06,3.06,0,0,0,.2,1c.07.2.12.47-.08.58s-.41,0-.57-.17a14.32,14.32,0,0,1-1.6-1.88,5.57,5.57,0,0,0-.94-.94,10.89,10.89,0,0,1-1-.67A1.88,1.88,0,0,1,104.51,374.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24,389.31c-7.79.21-11,5.43-11.37,8.14a19.9,19.9,0,0,0,5.48,1.25c5.36.26,9.1-.94,10.23-2.67C138.9,394,138.68,391.41,133.24,389.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,389.88a.43.43,0,0,1-.24-.08.32.32,0,0,1,0-.49c1.12-1.18,4.86-3.58,7.67-3.2a.35.35,0,0,1,.33.39.37.37,0,0,1-.43.29c-2.63-.34-6.11,2-7,3A.38.38,0,0,1,121,389.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.73,388a.4.4,0,0,1-.23-.08.32.32,0,0,1,0-.49c1.12-1.18,4.87-3.59,7.68-3.2a.34.34,0,0,1,.32.39.36.36,0,0,1-.43.29c-2.62-.35-6.11,2-7,3A.36.36,0,0,1,117.73,388Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,385.84a.41.41,0,0,1-.23-.09.32.32,0,0,1,0-.49c1.12-1.17,5.71-4.07,8.51-3.69a.36.36,0,0,1,.32.4.36.36,0,0,1-.43.29c-2.62-.35-6.94,2.53-7.83,3.46A.42.42,0,0,1,114.7,385.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,383.69a.41.41,0,0,1-.24-.08.32.32,0,0,1,0-.49c1.54-1.67,6.34-4.08,9.15-3.7a.37.37,0,0,1,.33.4.39.39,0,0,1-.43.29c-2.53-.34-7.1,2-8.47,3.46A.35.35,0,0,1,111.74,383.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.23,353.34l-17-2.52c-.82,10.38-.46,19.53-1.63,28.8-.21,1.74-2.15,13.5-2,17.17.23,5.52,7.47,6.24,8.34,3.08S72.6,382,72.85,380.53c1.59-5.56,3.2-11.81,6.5-23.64C79.5,356.38,80.08,353.84,80.23,353.34Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.79,402.21c-.12,3.42-1.17,6.24-2.75,7.59a6.45,6.45,0,0,1-6.15,1.39c-2.34-.65-5.06-2.3-5.84-5-.95-3.3-.48-5.14.19-8.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.72,378.48c-1,0-1.46,4.3-2.21,8.56-.81,4.56-2.4,6.39-3.11,10.13-.81,4.28-.5,6.7,1,9.37s7.24,5.49,10.29,1.89c2.48-2.93,3.48-6.13,3.46-10.44A85.74,85.74,0,0,1,72,387.12c.33-3.21,1.69-6.19.86-6.59-.57,1.61-1.17,4-1.49,3.39a6.23,6.23,0,0,1,0-1.22,1.38,1.38,0,0,0-.22-1.05,1.94,1.94,0,0,0-1.06-.49c-.95-.21-3.87-1-4.84-1.15a11.81,11.81,0,0,0-1.46-.12,4,4,0,0,0-1.24.1.85.85,0,0,0-.54.41,1.4,1.4,0,0,0-.08.49,2.91,2.91,0,0,1-.16.88c0,.13-.14.28-.28.24s-.15-.16-.15-.27c0-.52.11-.89.17-1.49,0-.28.09-.66.11-.94S61.69,378.76,61.72,378.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.92,399.65a11.26,11.26,0,0,0,1.14,7.08c1.53,2.67,7.34,5.19,10.76,1.92a11.3,11.3,0,0,0,3-6.44C69.2,399.27,58.75,397.33,55.92,399.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,397.84l-.12,0s-4.83-2.55-9.25-1.81a.36.36,0,0,1-.42-.27.34.34,0,0,1,.29-.39c4.67-.77,9.55,1.81,9.72,1.89a.33.33,0,0,1,.15.45A.39.39,0,0,1,68.68,397.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,392.79a.36.36,0,0,1-.3-.24.33.33,0,0,1,.25-.4c4.42-1.16,9.53,1.71,9.71,1.8a.33.33,0,0,1,.13.46.38.38,0,0,1-.49.11s-5-2.82-9.15-1.74A.26.26,0,0,1,59.69,392.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.08,389.78a.38.38,0,0,1-.3-.23.32.32,0,0,1,.24-.41c4.87-1.36,9.73,1.68,9.89,1.79a.31.31,0,0,1,.1.46.37.37,0,0,1-.5.08s-4.74-3-9.27-1.7A.45.45,0,0,1,60.08,389.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.53,386.4a.37.37,0,0,1-.29-.23.32.32,0,0,1,.23-.42c4.56-1.33,9.77,1.78,10,1.89a.31.31,0,0,1,.11.46.39.39,0,0,1-.5.1s-5.1-3.06-9.34-1.82A.44.44,0,0,1,60.53,386.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82,240.87a7.57,7.57,0,0,1-1.57,3.61c-4.61,5.71-6.81,11.29-7.65,22C68.53,292.89,68,320.35,68,320.35c-.3,2.33-2.53,6.37-4,18.43-1.29,10.55-1.66,25.07-1.66,25.07s12.36,2.22,16-1.14c2.06-7.84,8.48-27.7,12-39.09C93.43,313.28,95.92,298,95.92,298l3.75,21.54a60.33,60.33,0,0,0-.44,13.8c.55,7.12,3.06,25.62,3.06,25.62,2.26,2.47,12.93,2.45,15.72-1,0,0,3.1-31.1,3.56-39.67.84-15.94,2.56-46.51-2-70-.18-1-.66-4.85-.66-4.85C112.91,247.85,87.3,246.19,79.82,240.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.25,248.85a.33.33,0,0,0-.39.2c-.38,1.22-.67,2.32-1,3.38-1,3.83-1.77,6.6-4.93,9.46a10.73,10.73,0,0,1-7.74,2.58c1.67-7.86,4.72-14.06,9.36-19.08a.27.27,0,0,0,0-.41.33.33,0,0,0-.45,0c-4.78,5.16-7.89,11.54-9.57,19.64,0,0,0,0,0,0v0a72.12,72.12,0,0,0-1.27,9.81c-1,14.87-2.41,37.36-2.91,43.26a41.68,41.68,0,0,1-2.22,9.3c-.93,3-2,6.32-3,10.93-2.2,10-2.06,26.55-2.06,26.71a.32.32,0,0,0,.31.3h0a.3.3,0,0,0,.31-.3c0-.16-.13-16.67,2.06-26.59,1-4.59,2.07-7.93,3-10.88A41.91,41.91,0,0,0,72,317.83c.5-5.91,2-28.4,2.91-43.28a71.27,71.27,0,0,1,1.22-9.49l.33,0a11.24,11.24,0,0,0,8-2.77c3.29-3,4-5.81,5.1-9.74.28-1,.58-2.15,1-3.35A.31.31,0,0,0,90.25,248.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,360.58c2.24,2.23,12.24,3.83,15.91,2.13l-1.77,5.72s-2.64,1.14-7.82.45c-6-.8-6.57-2.69-6.57-2.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,358.93c3.06,1.13,12.25.89,15.72-1l-.32,4.77s-2.43,1.67-7.64,2-7.27-1.16-7.27-1.16Z",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.92,298l4.58-26a17.38,17.38,0,0,0,13.92-5.75s-.07,6.54-11.3,9L98,299.2l1.71,20.31Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--backpack--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,226.07c.41.19,4.58-.79,8.51-2.31V208.91a8.31,8.31,0,0,0-6.73,6.33C50,225.28,51,226.07,51,226.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,202c3.7-.06,8,1.77,9.32,4.65.22.49,1.77,4.27,1.77,4.27,2.08,10,5.83,35.88,3.2,39.08-4,4.8-23.41,14.2-31.94,13.93-7-.22-13.82-6.62-14.8-8.55-3.21-6.34,5.21-41.66,7.45-45.21C60.36,204.4,77,202.06,81.75,202Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,250c-4,4.8-23.41,14.2-31.94,13.93a15.51,15.51,0,0,1-5.54-1.33,3.49,3.49,0,0,0,5-2.6c.65-2.6,1.72-23.28,1.72-41l27.59-8.08C94.92,220.94,98.67,246.78,96,250Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.86,212a9.21,9.21,0,0,1,.89-2.21c3.61-5.75,20.28-8.09,25-8.17,3.7-.06,8,1.77,9.32,4.65.21.46,1.77,4.27,1.77,4.27C85.45,214.5,67,218.49,65,217.78,62.59,216.9,55.86,212,55.86,212Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81,239.35c.18-.08,2.81-1.92,3.11-2.06.54-.25,8,5.16,8.66,6.06.47.63-.82,13.48-1.14,14.14-.12.23-3,1.82-3.12,2.06-.32.66-8.19-4.85-8.65-6.14S50,239.72,50.81,239.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81,239.35c.18-.08,2.81-1.92,3.11-2.06.54-.25,8,5.16,8.66,6.06.47.63-.82,13.48-1.14,14.14-.12.23-3,1.82-3.12,2.06-.32.66-8.19-4.85-8.65-6.14S50,239.72,50.81,239.35Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46,245.42c.47.62-.81,13.47-1.14,14.13s-8.19-4.85-8.65-6.14.35-13.69,1.14-14.06C51.34,239.1,58.79,244.52,59.46,245.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.92,237.29c-.3.14-2.93,2-3.11,2.06.53-.24,8,5.17,8.65,6.06l3.12-2.06C61.9,242.45,54.46,237,53.92,237.29Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46,245.42c.47.62-.81,13.47-1.14,14.13s-8.19-4.85-8.65-6.14.35-13.69,1.14-14.06C51.34,239.1,58.79,244.52,59.46,245.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.58,243.35c-.56-.39-2.28.46-3,1.06s-1.65,3.53-3.56,3.93-4.49-2.19-5-3.81-1.05-5-.09-6.18a3.1,3.1,0,0,1,3.89-1C56.1,238.12,62.47,241.87,62.58,243.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.58,243.35c-.56-.39-2.28.46-3,1.06s-1.65,3.53-3.56,3.93-4.49-2.19-5-3.81-1.05-5-.09-6.18a3.1,3.1,0,0,1,3.89-1C56.1,238.12,62.47,241.87,62.58,243.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28,244.82a1.41,1.41,0,0,1,.61,1.33.57.57,0,0,1-.88.47,1.38,1.38,0,0,1-.61-1.33C53.48,244.79,53.87,244.58,54.28,244.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.25,218.65s-2.6-1.79-5.75-3.61-4.92-2.44-6,1.22A82.67,82.67,0,0,0,51,226.07c-.6-.29-.54-1.38-.12-6,.61-6.8-.25-9.83,6.79-12.55,10.91-4.22,20.07-7.54,26.31-6.14s7.71,4.89,8.84,9.25C92.84,210.58,85.26,217.46,65.25,218.65Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.37,202.16c5.82,1.71,7.89,4.19,11.17,9.07,3.42,5.1,8.17,11.89,13.28,19.55l20.27-3.6,0,10.79s-17.92,8.27-22,8.76-5.32-.8-8.07-3.95c-3-3.5-12.81-16.95-12.81-16.95Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.05,201.54c7.52,2,9.28,5.59,12.23,10.28s12.65,18.68,12.65,18.68-1.88,5.11-5,7.61c-4.07,3.23-5.68,3.78-5.68,3.78s-3.28-3.82-5.66-6.79c-6.38-8-6.73-8.45-6.73-8.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.05,201.54c7.52,2,9.28,5.59,12.23,10.28s12.65,18.68,12.65,18.68-1.88,5.11-5,7.61c-4.07,3.23-5.68,3.78-5.68,3.78s-3.28-3.82-5.66-6.79c-6.38-8-6.73-8.45-6.73-8.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Jar--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.81,215.09a10.6,10.6,0,0,0-1.22-.59,2.06,2.06,0,0,1-1.32-1.91v-2.34l-7.62,0v2.34a2.08,2.08,0,0,1-1.33,1.91,9.14,9.14,0,0,0-1.22.58c-1.76,1-2.64,2.33-2.64,3.66l-.06,23.44c0,1.33.87,2.66,2.62,3.68a14,14,0,0,0,12.7,0c1.76-1,2.64-2.33,2.64-3.66l.07-23.44C160.43,217.44,159.56,216.11,157.81,215.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.81,215.09a10.6,10.6,0,0,0-1.22-.59,2.06,2.06,0,0,1-1.32-1.91v-2.34l-7.62,0v2.34a2.08,2.08,0,0,1-1.33,1.91,9.14,9.14,0,0,0-1.22.58c-1.76,1-2.64,2.33-2.64,3.66l-.06,23.44c0,1.33.87,2.66,2.62,3.68a14,14,0,0,0,12.7,0c1.76-1,2.64-2.33,2.64-3.66l.07-23.44C160.43,217.44,159.56,216.11,157.81,215.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,228.09c-.12-3.67-14.74-7.47-15.61-4.36l-.05,18.44c0,.93.74,1.9,2,2.66a12.86,12.86,0,0,0,11.53,0c1.3-.75,2.05-1.72,2.05-2.65Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,228.09c-.06-3.61-14.74-7.47-15.61-4.36l-.05,18.44c0,.93.74,1.9,2,2.66a12.86,12.86,0,0,0,11.53,0c1.3-.75,2.05-1.72,2.05-2.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57,245.55c-3.21-1.84-3.2-4.82,0-6.64a12.9,12.9,0,0,1,11.61,0c3.21,1.84,3.2,4.81,0,6.64A13,13,0,0,1,145.57,245.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,212.71a9.89,9.89,0,0,0-6.1-1v-1.48h-2.24v2.34a2.08,2.08,0,0,1-1.33,1.91,9.14,9.14,0,0,0-1.22.58l0,0c-1.73,1-2.6,2.32-2.6,3.64l-.06,23.44c0,1.33.87,2.66,2.62,3.68a14.15,14.15,0,0,0,9.33,1.25c-7.31.48-9.06-2.62-9.06-4.86l.07-23a2.56,2.56,0,0,1,.67-2,4.85,4.85,0,0,0,.89.64,10,10,0,0,0,9.07,0c1.34-.78,2-1.81,1.87-2.82l-.15-.09A3.57,3.57,0,0,0,156,212.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.81,215.09a10.6,10.6,0,0,0-1.22-.59,2.06,2.06,0,0,1-1.32-1.91v-2.34h-.83c0,3.12,0,2.46,0,3.13s1.09,1,1.81,1.43,3.13,1.68,3.34,2.81a44.34,44.34,0,0,1,.06,5.54c0,2.44,0,16.67-.05,18.27a5.61,5.61,0,0,1-3.6,5.22,10,10,0,0,0,1.72-.76c1.76-1,2.64-2.28,2.64-3.68l.07-23.44C160.43,217.44,159.56,216.11,157.81,215.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,213.54v.66a3.18,3.18,0,0,1-1.89,2.62,10,10,0,0,1-9.07,0,4.33,4.33,0,0,1-1.41-1.23,2.43,2.43,0,0,1-.46-1.39v-.69a1.54,1.54,0,0,1,0-.43,3.45,3.45,0,0,1,1.83-2.19l.1-.05a10,10,0,0,1,9,.08,3.42,3.42,0,0,1,1.83,2.19A1.73,1.73,0,0,1,157.88,213.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,217.21v-2.36c0-.94.24.33-1.4.32-1.42,0-2.67-3.28-3.55-4.35l-.1.05a3.45,3.45,0,0,0-1.83,2.19,1.54,1.54,0,0,0,0,.43v.69a2.43,2.43,0,0,0,.46,1.39,4.33,4.33,0,0,0,1.41,1.23,10,10,0,0,0,9.07,0C154.22,217.52,152,218.1,152,217.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92,216.11c-2.5-1.45-2.49-3.8,0-5.24a10,10,0,0,1,9.07,0c2.5,1.45,2.49,3.79,0,5.23A10,10,0,0,1,146.92,216.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,211.31v1.33a1.73,1.73,0,0,1,0,.45,3.48,3.48,0,0,1-1.84,2.18,9,9,0,0,1-4,1,9.58,9.58,0,0,1-5.06-1.08,4.4,4.4,0,0,1-1.4-1.23,2.36,2.36,0,0,1-.42-.95,2.12,2.12,0,0,1,0-.44v-1.35a3.18,3.18,0,0,1,1.88-2.62,3.65,3.65,0,0,1,.34-.18,10.08,10.08,0,0,1,8.73.2A3.19,3.19,0,0,1,157.88,211.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.93,213.86c-2.5-1.46-2.5-3.8,0-5.24a10,10,0,0,1,9.07,0c2.5,1.46,2.5,3.8,0,5.24A10,10,0,0,1,146.93,213.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.52,214a4.4,4.4,0,0,0,1.4,1.23,9.58,9.58,0,0,0,5.06,1.08h0c0-.46.28-.82-1.4-1.15-1.39-.27-3.45-.86-4.41-2.38a3.24,3.24,0,0,1,1.11-4.32,3.65,3.65,0,0,0-.34.18,3.18,3.18,0,0,0-1.88,2.62v1.35a2.12,2.12,0,0,0,0,.44A2.36,2.36,0,0,0,145.52,214Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,207.89l0,2.92a.68.68,0,0,0,0,.14,1,1,0,0,0,.55.67,2.66,2.66,0,0,0,1.22.33,2.8,2.8,0,0,0,1.54-.32,1.23,1.23,0,0,0,.43-.37.71.71,0,0,0,.13-.28.68.68,0,0,0,0-.14l0-2.93a1,1,0,0,0-.57-.8l-.1-.05a3.1,3.1,0,0,0-2.66,0A1,1,0,0,0,149.53,207.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,207.89l0,2.92a.68.68,0,0,0,0,.14,1,1,0,0,0,.55.67,2.66,2.66,0,0,0,1.22.33,2.8,2.8,0,0,0,1.54-.32,1.23,1.23,0,0,0,.43-.37.71.71,0,0,0,.13-.28.68.68,0,0,0,0-.14l0-2.93a1,1,0,0,0-.57-.8l-.1-.05a3.1,3.1,0,0,0-2.66,0A1,1,0,0,0,149.53,207.89Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,207.88c0,.62.87,1.13,1.95,1.14s2-.49,2-1.11-.87-1.13-1.95-1.14S149.54,207.26,149.53,207.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,207.89c0,.22.31.4.69.4s.7-.17.7-.39-.31-.4-.69-.4S150.79,207.67,150.79,207.89Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,207.89c0,.22.31.4.69.4s.7-.17.7-.39-.31-.4-.69-.4S150.79,207.67,150.79,207.89Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,207.57l0,1a1.1,1.1,0,0,0,0,.18,1.31,1.31,0,0,0,.69.83,3.31,3.31,0,0,0,1.52.41,3.61,3.61,0,0,0,1.93-.39,1.74,1.74,0,0,0,.53-.46,1,1,0,0,0,.17-.36c0-.05,0-.11,0-.17v-1a1.22,1.22,0,0,0-.7-1l-.13-.07a3.83,3.83,0,0,0-3.32.05A1.2,1.2,0,0,0,149.05,207.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,207.57l0,1a1.1,1.1,0,0,0,0,.18,1.31,1.31,0,0,0,.69.83,3.31,3.31,0,0,0,1.52.41,3.61,3.61,0,0,0,1.93-.39,1.74,1.74,0,0,0,.53-.46,1,1,0,0,0,.17-.36c0-.05,0-.11,0-.17v-1a1.22,1.22,0,0,0-.7-1l-.13-.07a3.83,3.83,0,0,0-3.32.05A1.2,1.2,0,0,0,149.05,207.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,207.56c0,.77,1.08,1.41,2.43,1.42s2.44-.61,2.44-1.39-1.08-1.4-2.42-1.41S149.06,206.79,149.05,207.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,207.57c0,.28.39.5.86.5s.87-.21.87-.49-.38-.5-.86-.5S150.62,207.3,150.62,207.57Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,207.57c0,.28.39.5.86.5s.87-.21.87-.49-.38-.5-.86-.5S150.62,207.3,150.62,207.57Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingers--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.41,223.78a5.73,5.73,0,0,1,2.64,4.07l-2.67.38Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,226.2c1.22-.88,2.88,1.3,1.52,3.45,1,0,.95,1.94,0,3.2,1,.22.58,2.36-.47,3.45.8,0,.7,1.87-1.06,2.92-1,.57-2.53-.18-.53-2.47-1.84.59-1.4-2.57.19-3.2-2.42.69-1.28-2.57-.49-3.13C158.64,229.9,158.57,228,161,226.2Z",
    style: {
      fill: "#b16668"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M72.53,255.67c3.16-9.24,5.2-14.58,5.28-17.51,0,0-2.66-14.74-3-18.21-1-9,.63-13.28,2.44-14.24A65,65,0,0,1,84,203.49c6.26-1.78,15.23-2,21-1.92,2.19.12,2.86.19,2.86.19a53.84,53.84,0,0,1,7.86,7.16c4.63,5.38,6.08,9,5.34,14.52A13.27,13.27,0,0,1,118,230c-.35,2.67-.94,10.25-.94,10.25.07,3-.13,2.91,1.37,10.08C113.68,264.42,82.1,263.53,72.53,255.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.67,164.69A7.9,7.9,0,0,0,78,166.5c-2.16,2.33-2.67,5.72-3,8.89q-.9,8.22-1.36,16.49c-.13,2.47-.59,4.91-.81,7.39q-.37,4.17-.6,8.35a3,3,0,0,0,.38,2.07,2.74,2.74,0,0,0,1.7.86A12.67,12.67,0,0,0,83.32,209c4.23-2.58,6.59-7.58,6.92-12.53a41.26,41.26,0,0,0-.89-9.58,68.35,68.35,0,0,0-1.44-6.94c-.41-1.44-.92-2.85-1.25-4.31a18.61,18.61,0,0,1,.21-9.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.47,164.63a9.16,9.16,0,0,0-3,4.89,2.56,2.56,0,0,0,0,1.55,1.91,1.91,0,0,0,2,1A3.71,3.71,0,0,0,84.52,171a7.88,7.88,0,0,0,2.38-4.49,2.64,2.64,0,0,0-.71-2.53C85.31,163.4,84.15,164.07,83.47,164.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,176.58c1.84-3.89.32-9.16-1.66-11.68-2.86-3.63-7.43-5.3-14.4-5.08-5.3.17-11.71,2.33-12.87,7.73-5,2.34-3.44,9.19-2.22,12.1,2.56,6.1,6.32,10.92,6.3,14.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2,168.29c1.18.93,3.14,3.54,2.84,8.29-.15,1.43.31,3.21.31,5.89,0,10.15-2.82,12.27-5.57,13.47-1.63.71-2.54.83-5.15.8v4.7s5.94,9.27,3.24,17.39h0c-12.32-8.35-17.73-18.13-17.74-18.15L88,189.23h0c-.06.05-1.63,1.42-4.18,0-2.77-1.5-3.84-6.17-2-8.31s4.4-.83,5.55,1.07,4,1.37,3.13-1.51c1.3-.62,2.92-1.94,1.73-7.24a5.87,5.87,0,0,1,1.52-4.84c2.15-1.91,6.33-1.46,8.69.91C105.67,166.7,107.74,166.36,110.2,168.29Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.09,187.14l4.69,1.65a2.39,2.39,0,0,1-3.09,1.57A2.62,2.62,0,0,1,100.09,187.14Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.78,190.47a2.23,2.23,0,0,0-2.22-2.21,2.42,2.42,0,0,0-.54.07,2.59,2.59,0,0,0,1.67,2A2.28,2.28,0,0,0,102.78,190.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.84 176.8 104.47 185.86 109 183.72 103.84 176.8",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,196.74c-3.26-.19-10.21-2-11.91-6.29,0,0,.25,3.08,4.25,5.47a20.91,20.91,0,0,0,7.65,2.28Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,179.65a1.44,1.44,0,0,1-1.57,1.3,1.44,1.44,0,0,1,.26-2.87A1.46,1.46,0,0,1,100.15,179.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9,179.29a1.44,1.44,0,1,1-1.08-1.73A1.45,1.45,0,0,1,110.9,179.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,173.65a2.06,2.06,0,0,0-2.49,1.52l4,1A2.07,2.07,0,0,0,110.36,173.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,174.41a2.06,2.06,0,0,0-1.09,2.71l3.79-1.62A2.06,2.06,0,0,0,96.84,174.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.31,162.85H93.84C83.4,167,87.24,180.4,89.43,182c6.21-2.61,5.8-8.81,5.34-12.33,3.15,2.94,8.39,5.12,10.86,5.38a17.24,17.24,0,0,1-2.1-4.78,12.55,12.55,0,0,0,4.89,5.29c3.82,2.21,6.43.74,6.43.74S116.15,167,109.31,162.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.08,200a32.48,32.48,0,0,0,1.41,5.83c1.25,4,1.71,7.25,2,15.88s-2.89,49-2,58.73c-6.41,0-16.64-4.25-21.42-9.42a109.18,109.18,0,0,1,3.47-19.51c2.29-8.72,4.68-9.42,4.19-14.09s-4.92-23.25-1.13-32.73a53.34,53.34,0,0,0,6.63-1.29C88.3,202,89.08,200,89.08,200Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.08,200a32.48,32.48,0,0,0,1.41,5.83c1.25,4,1.71,7.25,2,15.88s-2.89,49-2,58.73c-6.41,0-16.64-4.25-21.42-9.42a109.18,109.18,0,0,1,3.47-19.51c2.29-8.72,4.68-9.42,4.19-14.09s-4.92-23.25-1.13-32.73a53.34,53.34,0,0,0,6.63-1.29C88.3,202,89.08,200,89.08,200Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,199.56l.23.88c0,2.47,5.09,6.4,8.66,12.24s4.14,11.52,3.89,19,1.7,35.41,2.46,39.06a10.16,10.16,0,0,0,4.23-6.08c-.59-4.42-1.65-12.11-2.29-14.8s-.6-7.09-.6-12.6a48.73,48.73,0,0,1,.45-7.15s3.53-4.38,1.46-12.51-13.19-16-13.19-16-.34-.13-2.18-.54A12.13,12.13,0,0,1,102.75,199.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,199.56l.23.88c0,2.47,5.09,6.4,8.66,12.24s4.14,11.52,3.89,19,1.7,35.41,2.46,39.06a10.16,10.16,0,0,0,4.23-6.08c-.59-4.42-1.65-12.11-2.29-14.8s-.6-7.09-.6-12.6a48.73,48.73,0,0,1,.45-7.15s3.53-4.38,1.46-12.51-13.19-16-13.19-16-.34-.13-2.18-.54A12.13,12.13,0,0,1,102.75,199.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.15,196.56a12.39,12.39,0,0,1-4,6.31s1.68,7.84,1.39,11.69-1.08,7.58,0,7.55a28,28,0,0,0,4.27-1s-2.56,3.75-2.31,4.93,4.22,14.39,4.22,14.39,1.66-15.29,1.4-19.77-1.07-12.72-2.66-17.43C89.38,199.91,88.15,196.56,88.15,196.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65,238.3c.23-4.31,2.48-15.1,2.77-17.26s-2.77-4.11-2.77-4.11,1.85.47,2.46,0-3.11-5.86-6.28-9.4-9.21-8.93-9.21-8.93v2.84a40,40,0,0,1,4.63,6.09C110,212.1,115.19,217.06,115.65,238.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5,203.52s6.57,5.63,7.6,16.45c2.63,27.37-17.39,33-17.39,33A53.62,53.62,0,0,1,73.35,246s11.79-10.79,10.48-24.77c-.93-10-5.7-15.92-8.24-16.56C75.59,204.71,78.1,204,81.5,203.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,253.34a18.21,18.21,0,0,0,7-4.46c5-4.52,5.22-5.2,9.32-9.19,1.39-1.36,2.63-2.71,3.22-3.31a16.83,16.83,0,0,0,3.1-3.41,10.31,10.31,0,0,0,1.67-3.9c.13-1.48.59-3,.25-4.5-.1-.43-.27-.85-.35-1.29a9.32,9.32,0,0,1-.08-1.83,8.88,8.88,0,0,0-.54-3.15,5.66,5.66,0,0,0-1.55-2.19,1.94,1.94,0,0,0-1.94-.58c.19.79.33,1.46.5,2.38a6.62,6.62,0,0,1-1.49,3.58c-1.52,2.19-2.85,3.35-3.06,2.93s.32-1.77,0-3.91-.93-2.89-1.6-3c-1-.22-1,.91-1.35,2.65-.43,2.07-1.26,3.23-1.23,6.26,0,2.65.49,3.25-.93,4.5-.82.72-3.63,2.46-3.63,2.46s.68-2.92,1.78-7.9c2.14-9.67,2.12-19.16-1.71-20.41-4.6,1.36-9.08,4-11.11,11.85-2.16,8.39-2.17,9.64-4,26.2C59.2,255.14,64.24,254.73,68.22,253.34Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.55,233.36C72.29,236,65.07,240,64.29,244.05c0,0,0-3.19,4.27-7.22a60,60,0,0,1,7.61-6.17Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.59,204.71c-3.22.75-7.27,2.9-9.16,6.43s-2.4,6.06-3.6,11.23-3.07,23.15-2.52,23.89a32.18,32.18,0,0,1,15.24-12.9s2.06-7.46,2.88-12.53S80.86,207.15,75.59,204.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.59,204.71c-3.22.75-7.27,2.9-9.16,6.43s-2.4,6.06-3.6,11.23-3.07,23.15-2.52,23.89a32.18,32.18,0,0,1,15.24-12.9s2.06-7.46,2.88-12.53S80.86,207.15,75.59,204.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lines--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.72,180.18c0-.08-.26-.29-.32-.11a17.24,17.24,0,0,0-.21,3,6,6,0,0,1-.82,2.52,5.29,5.29,0,0,1-2,1.72,3.91,3.91,0,0,1-1.24.44,3.16,3.16,0,0,1-.87,0c-.3,0-.58-.15-.89-.18a.19.19,0,0,0-.21.26c.18.42.73.57,1.14.65a3.26,3.26,0,0,0,1.58-.1,6.2,6.2,0,0,0,2.78-1.82,5.44,5.44,0,0,0,1.26-2.91,9.64,9.64,0,0,0,.07-1.7c0-.26,0-.52,0-.78A3.27,3.27,0,0,0,252.72,180.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.94,183c-.43.18-.82.44-1.26.6a5.34,5.34,0,0,1-1.25.32,4.79,4.79,0,0,1-2.51-.33,5.17,5.17,0,0,1-2-1.48,6.83,6.83,0,0,1-.74-1.1,6.17,6.17,0,0,1-.53-1.06c-.06-.16-.45-.31-.42,0a5.22,5.22,0,0,0,.38,1.65,4.87,4.87,0,0,0,.81,1.25,5.47,5.47,0,0,0,5.16,1.9,5.22,5.22,0,0,0,1.44-.44,2.91,2.91,0,0,0,1.27-.94C263.42,183.08,263.1,182.88,262.94,183Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.87,186.65l-.06,0-.05,0-.15-.11a1.37,1.37,0,0,1-.22-.19,1.3,1.3,0,0,1-.33-.65,1.75,1.75,0,0,1,0-.72c.07-.25.21-.48.29-.73s-.34-.44-.52-.29a2,2,0,0,0-.58,1.24,2,2,0,0,0,.1.94,1.87,1.87,0,0,0,.53.76,1.31,1.31,0,0,0,.55.28.94.94,0,0,0,.64,0,.2.2,0,0,0,.07-.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,209.23a3.55,3.55,0,0,0-1.93-.94,4.2,4.2,0,0,0-1.12,0,2.28,2.28,0,0,0-1.16.4.22.22,0,0,0-.05.3c.05.08.24.22.34.16a3.34,3.34,0,0,1,.71-.17,3.86,3.86,0,0,1,.49-.06,4,4,0,0,1,.84.1,2.36,2.36,0,0,1,1.38.87,2.4,2.4,0,0,1,.09,1.77,6.64,6.64,0,0,1-.25.87c-.05.16-.09.32-.15.47a2.32,2.32,0,0,0-.16.44c0,.17.24.43.4.28a3.15,3.15,0,0,0,.74-1.18,5.41,5.41,0,0,0,.32-1.11A2.39,2.39,0,0,0,250.9,209.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.05,214.1a4.76,4.76,0,0,0-.91-1.81,5.47,5.47,0,0,0-3.34-1.83,5.73,5.73,0,0,0-5.17,1.77,2.77,2.77,0,0,0-.9,1.57.27.27,0,0,0,.42.2c.39-.37.66-.85,1-1.22a5.21,5.21,0,0,1,1.37-1,5,5,0,0,1,3.17-.37,4.62,4.62,0,0,1,2.73,1.64,4.81,4.81,0,0,1,.76,1.6,5.81,5.81,0,0,0,.56,1.66c.11.15.41.22.47,0A4.56,4.56,0,0,0,262.05,214.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.8,207q.09,0,0-.06a.33.33,0,0,0-.17-.07,1.1,1.1,0,0,0-.31,0,3.55,3.55,0,0,0-.73,0,4.55,4.55,0,0,0-1.21.35,4.94,4.94,0,0,0-2.88,3.62,4.05,4.05,0,0,0-.05,1.25,4.74,4.74,0,0,0,.56,1.58c.07.14.33.18.27,0a5.58,5.58,0,0,1-.05-2.57,4.63,4.63,0,0,1,.82-1.84,4.22,4.22,0,0,1,1.59-1.28,4.07,4.07,0,0,1,1-.31,7.09,7.09,0,0,1,.78-.14,1,1,0,0,0,.24,0,1.69,1.69,0,0,0,.24-.08C268,207.26,267.93,207,267.8,207Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273,138.69a23.17,23.17,0,0,1-6.26,15.87l-1.92,1.83a23.2,23.2,0,0,1-32.76-32.66l1.84-1.92A23.2,23.2,0,0,1,273,138.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76,113.53a25.19,25.19,0,0,0-4.12,50l2.84,7.3a1.46,1.46,0,0,0,2.73,0l2.81-7.3a25.19,25.19,0,0,0-4.26-50ZM273,138.69a23.17,23.17,0,0,1-6.26,15.87l-1.92,1.83a23.2,23.2,0,0,1-32.76-32.66l1.84-1.92A23.2,23.2,0,0,1,273,138.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,138.69a23.17,23.17,0,0,1-6.26,15.87l-1.92,1.83a23.2,23.2,0,0,1-32.76-32.66l1.84-1.92A23.2,23.2,0,0,1,273,138.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249,130.42a.67.67,0,0,1,.49.21.64.64,0,0,1,.21.48v16.64a.67.67,0,0,1-.21.49.66.66,0,0,1-.49.2h-3.37a.66.66,0,0,1-.49-.2.67.67,0,0,1-.21-.49v-6.31h-5.71v6.31a.67.67,0,0,1-.21.49.66.66,0,0,1-.49.2h-3.37a.69.69,0,0,1-.49-.19.64.64,0,0,1-.21-.5V131.11a.64.64,0,0,1,.21-.48.67.67,0,0,1,.49-.21h3.37a.67.67,0,0,1,.49.21.64.64,0,0,1,.21.48v6.21H245v-6.21a.64.64,0,0,1,.21-.48.67.67,0,0,1,.49-.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65,132.94a.65.65,0,0,1-.21.49.67.67,0,0,1-.49.21h-3.24a.67.67,0,0,1-.49-.21.65.65,0,0,1-.21-.49v-2.6a.67.67,0,0,1,.21-.49.7.7,0,0,1,.49-.2H257a.7.7,0,0,1,.49.2.67.67,0,0,1,.21.49Zm0,14.81a.67.67,0,0,1-.21.49.66.66,0,0,1-.49.2h-3.24a.66.66,0,0,1-.49-.2.67.67,0,0,1-.21-.49v-12a.72.72,0,0,1,.7-.7H257a.72.72,0,0,1,.7.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.35,142.21a.65.65,0,0,1-.21.49.67.67,0,0,1-.49.21h-3.24a.67.67,0,0,1-.49-.21.65.65,0,0,1-.21-.49v-11.1a.64.64,0,0,1,.21-.48.67.67,0,0,1,.49-.21h3.24a.67.67,0,0,1,.49.21.64.64,0,0,1,.21.48Zm0,5.54a.67.67,0,0,1-.21.49.66.66,0,0,1-.49.2h-3.24a.66.66,0,0,1-.49-.2.67.67,0,0,1-.21-.49v-2.6a.72.72,0,0,1,.7-.7h3.24a.72.72,0,0,1,.7.7Z",
    style: {
      fill: "#BA68C8"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsAmico);
export default __webpack_public_path__ + "static/media/Students-amico.5d49bf2f9c4381766c189e07cd31111c.svg";
export { ForwardRef as ReactComponent };